'use strict';

window.addEventListener('load', () => {

    window.groupmeet = window.groupmeet || (function () {

        // CONFIG
        const SIG_SERVER = (window.location.hostname.indexOf('localhost') === -1) ? 'https://' + window.location.hostname + ':9966' : 'http://localhost:9966';
        const KEY_SERVER = (window.location.hostname.indexOf('localhost') === -1) ? 'https://' + window.location.hostname + ':9967' : 'http://localhost:9967';
        const DEFAULT_USERNAME = 'Attendee';
        const ID_MARK = ' | ';
        const SELF_ID = '(YOU)';
        const MAX_MESS_SIZE = 16384; // 65535;
        const INIT_DATE = new Date();
        const TIMEZONE_OFFSET = INIT_DATE.getTimezoneOffset() * 60000;

        // STUN Server List: https://gist.github.com/zziuni/3741933
        const ICE_SERVERS = [{
            urls: 'stun:stun.l.google.com:19302'
        },{
            urls: 'stun:stun.services.mozilla.com:3478'
        }];

        // Unreliable mobile detection to assist browser feature support detection.
        const MOBILE_AGENT = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
        || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4));

        // Passive event listener feature detection
        let PASSIVE_SUPPORT = false;
        try {
            let opts = Object.defineProperty({}, 'passive', {
                get: function() {
                    PASSIVE_SUPPORT = true;
                }
            });
            window.addEventListener('testPassive', null, opts);
            window.removeEventListener('testPassive', null, opts);
        } catch (e) {}

        // String hashCode functionality
        Object.defineProperty(String.prototype, 'hashCode', {
            value: function () {
                let hash = 0, i, chr;
                for (i = 0; i < this.length; i++) {
                    chr   = this.charCodeAt(i);
                    hash  = ((hash << 5) - hash) + chr;
                    hash |= 0;
                }
                return hash;
            }
        });

        // Shorthand functions for ease of use.
        let byId = document.getElementById.bind(document);
        let byClassName = document.getElementsByClassName.bind(document);
        let createEle = document.createElement.bind(document);

        // STATE
        let room = {
            id: '',
            channel: '',
            name: 'room',
            keyURL: '',
            startTime: 0,
            locked: null,
            viewMode: ''
        };

        let user = {
            pid: undefined,
            name: DEFAULT_USERNAME,
            status: '',
            host: false,
            blocked: false,
            key: [],
            media: null,
            stream: null,
            permissions: {
                audio: false,
                video: false,
                screenshare: false,
                play: true
            },
            activeDevices: [],
            screensharing: false,
            browser: {},
            filter: {
                active: {},
                saved: {}
            }
        };

        let peers = {};
        let peerUtils = {};

        let ui = {
            controls: {},
            sidebar: {},
            settings: {}
        };

        let chat = {
            messages: [],
            notifications: 0
        };

        let files = {};

        let socket = {};
        let keysPressed = {};

        // User Interface (UI)
        let assets = {
            icons: {
                // Multi-use
                person: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" width="18px" height="18px"><title>Attendee</title><path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/><path d="M0 0h24v24H0z" fill="none"/></svg>',
                close: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="black" width="18px" height="18px"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/><path d="M0 0h24v24H0z" fill="none"/></svg>',
                // File sharing
                file: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="black" width="18px" height="18px"><path d="M0 0h24v24H0z" fill="none"></path><path d="M6 2c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6H6zm7 7V3.5L18.5 9H13z"></path></svg>',
                image: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" width="18px" height="18px"><path d="M0 0h24v24H0z" fill="none"/><path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"/></svg>',
                download: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" width="18px" height="18px"><path d="M0 0h24v24H0z" fill="none"/><path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/></svg>',
                delete: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" width="18px" height="18px"><path d="M0 0h24v24H0z" fill="none"/><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/></svg>',
                // Per-video controls
                fullscreen: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" width="18px" height="18px"><path d="M0 0h24v24H0z" fill="none"/><path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"/></svg>',
                fullscreenOff: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" width="18px" height="18px"><path d="M0 0h24v24H0z" fill="none"/><path d="M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z"/></svg>',
                unmuted: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" width="18px" height="18px"><path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/><path d="M0 0h24v24H0z" fill="none"/></svg>',
                muted: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" width="18px" height="18px"><path d="M7 9v6h4l5 5V4l-5 5H7z"/><path d="M0 0h24v24H0z" fill="none"/></svg>',
                draggable: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" width="18px" height="18px"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/></svg>',
                // Userlist
                host: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" width="18px" height="18px"><title>Host</title><path d="M0 0h24v24H0z" fill="none"/><path d="M11.99 2c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10zm3.61 6.34c1.07 0 1.93.86 1.93 1.93 0 1.07-.86 1.93-1.93 1.93-1.07 0-1.93-.86-1.93-1.93-.01-1.07.86-1.93 1.93-1.93zm-6-1.58c1.3 0 2.36 1.06 2.36 2.36 0 1.3-1.06 2.36-2.36 2.36s-2.36-1.06-2.36-2.36c0-1.31 1.05-2.36 2.36-2.36zm0 9.13v3.75c-2.4-.75-4.3-2.6-5.14-4.96 1.05-1.12 3.67-1.69 5.14-1.69.53 0 1.2.08 1.9.22-1.64.87-1.9 2.02-1.9 2.68zM11.99 20c-.27 0-.53-.01-.79-.04v-4.07c0-1.42 2.94-2.13 4.4-2.13 1.07 0 2.92.39 3.84 1.15-1.17 2.97-4.06 5.09-7.45 5.09z"/></svg>',
                authorized: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" width="18px" height="18px"><path d="M0 0h24v24H0z" fill="none"/><path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z"/></svg>',
                // Device Selection
                camera: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="black" width="18px" height="18px"><path d="M0 0h24v24H0z" fill="none"/><path d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z"/></svg>',
                cameraOff: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="black" width="18px" height="18px"><path d="M0 0h24v24H0zm0 0h24v24H0z" fill="none"/><path d="M21 6.5l-4 4V7c0-.55-.45-1-1-1H9.82L21 17.18V6.5zM3.27 2L2 3.27 4.73 6H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.21 0 .39-.08.54-.18L19.73 21 21 19.73 3.27 2z"/></svg>',
                screenshare: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" width="18px" height="18px"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M20 18c1.1 0 1.99-.9 1.99-2L22 6c0-1.11-.9-2-2-2H4c-1.11 0-2 .89-2 2v10c0 1.1.89 2 2 2H0v2h24v-2h-4zm-7-3.53v-2.19c-2.78 0-4.61.85-6 2.72.56-2.67 2.11-5.33 6-5.87V7l4 3.73-4 3.74z"/></svg>',
                screenshareOff: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" width="18px" height="18px"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M21.22 18.02l2 2H24v-2h-2.78zm.77-2l.01-10c0-1.11-.9-2-2-2H7.22l5.23 5.23c.18-.04.36-.07.55-.1V7.02l4 3.73-1.58 1.47 5.54 5.54c.61-.33 1.03-.99 1.03-1.74zM2.39 1.73L1.11 3l1.54 1.54c-.4.36-.65.89-.65 1.48v10c0 1.1.89 2 2 2H0v2h18.13l2.71 2.71 1.27-1.27L2.39 1.73zM7 15.02c.31-1.48.92-2.95 2.07-4.06l1.59 1.59c-1.54.38-2.7 1.18-3.66 2.47z"/></svg>',
                microphone: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="black" width="18px" height="18px"><path d="M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z"/><path d="M0 0h24v24H0z" fill="none"/></svg>',
                nomic: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="black" width="18px" height="18px"><path d="M0 0h24v24H0zm0 0h24v24H0z" fill="none"/><path d="M19 11h-1.7c0 .74-.16 1.43-.43 2.05l1.23 1.23c.56-.98.9-2.09.9-3.28zm-4.02.17c0-.06.02-.11.02-.17V5c0-1.66-1.34-3-3-3S9 3.34 9 5v.18l5.98 5.99zM4.27 3L3 4.27l6.01 6.01V11c0 1.66 1.33 3 2.99 3 .22 0 .44-.03.65-.08l1.66 1.66c-.71.33-1.5.52-2.31.52-2.76 0-5.3-2.1-5.3-5.1H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c.91-.13 1.77-.45 2.54-.9L19.73 21 21 19.73 4.27 3z"/></svg>',
                play: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" width="18px" height="18px"><path d="M0 0h24v24H0z" fill="none"/><path d="M10 16.5l6-4.5-6-4.5v9zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/></svg>'
            },
            text: {
                en: {}
            }
        };

        // For fixed DOM elements
        let dom = {};

        // Cache all reused fixed id DOM objects to the dom object.
        [   'content',
                'streams',
                'content__prompt',
                    'prompt__message',
                'content__fullscreen',
                    'fullscreen__panel',
                    'fullscreen__message',
                'content__information',
                    'information__shareroom',
                        'share__text',
                        'information__shareform',
                            'shareform__link',
                            'shareform__copybutton',
                    'information__newroomform',
                        'newroomform__link',
                        'newroomform__name',
                        'hostedroom',
                        'scheduledroom',
                            'scheduler__date',
                            'scheduler__hour',
                            'scheduler__minute',
                            'scheduler__meridiem',
                    'information__host',
                        'keycode__input',
                        'keycode__key',
                        'host__form',
                            'host__validate',
                        'content__namechange',
                            'namechange__name',
                            'namechange__form',
                    'information__closer',
            'background',
            'overlay__usercount',
                'overlay__usernumber',
            'overlay__lockroom',
                'overlay__lockroombutton',
                'lockroombutton__popup',
            'overlay__fullscreen',
                'overlay__fullscreenbutton',
            'overlay__streamview',
                'overlay__streamviewbutton',
            'overlay__chat',
                'overlay__chatbutton',
            'controls__microphone',
                'controls__microphonebutton',
                'popup__microphone',
            'controls__camera',
                'controls__camerabutton',
                'popup__camera',
            'controls__call',
                'controls__callbutton',
                'popup__call',
            'controls__namechange',
            'controls__info',
            'sidebar',
                'sidebar__expandedbutton',
                'sidebar__chatbutton',
                    'chatbutton__notifications',
                'sidebar__userlistbutton',
                'sidebar__settingsbutton',
                'chat',
                    'chat__content',
                    'chat__form',
                    'chat__selector',
                    'chat__input',
                    'chat__file',
                    'chat__messagepreview',
                    'chat__filepreview',
                        'filepreview__icon',
                        'filepreview__name',
                        'filepreview__size',
                        'filepreview__close',
                    'chat__pollpreview',
                        'pollpreview__list',
                            'pollpreview__close',
                        'pollpreview__multi',
                        'pollpreview__add',
                    'chat__sendbutton',
                    'emojipicker',
                        'emoji__list',
                    'polltoggle',
                'userlist',
                    'userlist__list',
                'settings',
                    'darkmode',
                    'mirror',
                    'showself',
                    'fadeout',
                    'hiddenchat',
                    'applyfilters',
                    'brightness',
                    'contrast',
                    'saturate',
                    'sepia',
                    'hue-rotate'
        ].forEach((val) => {
            dom[val] = byId(val);
        });

        // Simple event handler, current events:
        // mute (bool state)
        // dim (bool state)
        // viewmode (string mode)
        // media (string 'display'/'user')
        // chat (obj ChatMessage)
        // join (obj User)
        // blocked (string status)
        // keyerror (string error)
        // admin (string cmd)
        // kicked
        // quit
        // namechange (string name)
        // peerjoin (obj Peer)
        // peermedia (obj Peer)
        // peerremove (obj Peer)
        const events = (function () {

            const evts = {};

            function on (evt, callback) {
                if (evts.hasOwnProperty(evt))
                    evts[evt].push(callback);
                else
                    evts[evt] = [ callback ];
            }

            function off (evt, callback) {
                if (evts.hasOwnProperty(evt)) {
                    const index = evts[evt].indexOf(callback);
                    if (index >= 0) 
                        evts[evt].splice(index, 1);
                }
            }

            function emit (evt, param = undefined) {
                if (evts.hasOwnProperty(evt)) {
                    for (let i = 0, len = evts[evt].length; i < len; i++) {
                        if (param !== undefined) evts[evt][i](param);
                        else evts[evt][i]();
                    }
                }
            }

            return {
                on: on,
                off: off,
                emit: emit
            };
        })();

        // Initialize browser related parameters.
        (function () {

            // Get browser information.
            user.browser = (function () {

                var objAgent = navigator.userAgent;
                var objbrowserName = navigator.appName;
                var objfullVersion = '' + parseFloat(navigator.appVersion);
                var objBrMajorVersion = parseInt(navigator.appVersion, 10);
                var objOffsetName, objOffsetVersion, ix;
            
                // In Chrome
                if ((objOffsetVersion = objAgent.indexOf('Chrome')) != -1) {
                    objbrowserName = 'Chrome';
                    objfullVersion = objAgent.substring(objOffsetVersion + 7);
                }
                // In Microsoft internet explorer
                else if ((objOffsetVersion = objAgent.indexOf('MSIE')) != -1) {
                    objbrowserName = 'Microsoft Internet Explorer';
                    objfullVersion = objAgent.substring(objOffsetVersion + 5);
                }
                // In Firefox
                else if ((objOffsetVersion=objAgent.indexOf('Firefox')) != -1) {
                    objbrowserName = 'Firefox';
                }
                // In Safari
                else if ((objOffsetVersion=objAgent.indexOf('Safari')) != -1) {
                    objbrowserName = 'Safari';
                    objfullVersion = objAgent.substring(objOffsetVersion + 7);
                    if ((objOffsetVersion = objAgent.indexOf('Version')) != -1)
                        objfullVersion = objAgent.substring(objOffsetVersion + 8);
                }
                // For other browser "name/version" is at the end of userAgent
                else if ((objOffsetName = objAgent.lastIndexOf(' ') + 1) < (objOffsetVersion = objAgent.lastIndexOf('/')))
                {
                    objbrowserName = objAgent.substring(objOffsetName, objOffsetVersion);
                    objfullVersion = objAgent.substring(objOffsetVersion + 1);
                    if (objbrowserName.toLowerCase() == objbrowserName.toUpperCase()) {
                        objbrowserName = navigator.appName;
                    }
                }
            
                // Trimming the fullVersion string at semicolon/space if present
                if ((ix = objfullVersion.indexOf(';')) != -1)
                    objfullVersion = objfullVersion.substring(0, ix);
            
                if ((ix = objfullVersion.indexOf(' ')) != -1)
                    objfullVersion = objfullVersion.substring(0, ix);
            
                objBrMajorVersion = parseInt('' + objfullVersion, 10);
            
                if (isNaN(objBrMajorVersion)) {
                    objfullVersion  = '' + parseFloat(navigator.appVersion);
                    objBrMajorVersion = parseInt(navigator.appVersion, 10);
                }

                return {
                    name: encodeURI(objbrowserName),
                    version: encodeURI(objfullVersion)
                };

            })();

            // Split URL for parameters.
            const spliturl = new URL(window.location.href).pathname.split('/');
            if (spliturl.length > 1 && spliturl[1].length > 0) {
                room.name = spliturl[1];
                if (spliturl.length > 2) {
                    room.id = spliturl[2];
                    if (spliturl.length > 3) {
                        room.startTime = spliturl[3];
                        if (spliturl.length > 4) {
                            user.name = spliturl[4];
                        }
                    }
                }
            }

            room.keyURL = KEY_SERVER + 
                '?room=' + ((room.name === 'room') ? 'room' : room.name.hashCode() >>> 0) +
                ((room.id !== 'default') ? ((room.id === 'hosted') ? '&hosted=1' : ('&id=' + room.id)) : '' ) +
                ((room.startTime !== 0) ? ('&starttime=' + room.startTime) : '' ) +
                '&browser=' + user.browser.name + '&ver=' + user.browser.version;

            // TBD: Probably removeable if ID is covered in key server fetch.
            if (room.id === 'hosted') room.id = '';

        })();

        // User: Mute
        user.mute = function (state) {
            if (user.stream) {
                user.stream.getTracks().forEach( (track) => {
                    if (track.kind === 'audio') track.enabled = !state;
                });
                events.emit('mute', state);
            }
        };

        // User: Dim Camera
        user.dim = function (state) {
            if (user.stream) {
                user.stream.getTracks().forEach( (track) => {
                    if (track.kind === 'video') track.enabled = !state;
                });
                events.emit('dim', state);
            }
        };

        // User: Quit Room or Kicked
        user.quit = function (kicked = false) {
            dom.information__shareroom.classList.toggle('nondisplay', true);
            dom.information__host.classList.toggle('nondisplay', true);
            dom.content__information.classList.toggle('content__popup--hidden', false);
            if (user.stream) user.stream.getTracks().forEach((track) => { track.stop(); });
            if (user.media) user.media.element.remove();
            socket.quit();

            ui.fullscreenPrompt.prompt((kicked) ? 
                'You have been kicked from the room.' : 'You left the room.');
            chat.add('notification', {}, (kicked) ? 
                'has been kicked from the room.' : 'left the room.');
            events.emit((kicked) ? 'kicked' : 'quit');
        };

        // User: Name Change
        user.changeName = function (value) {
            if (value !== user.name || value !== '') {
                chat.add('notification', {}, 'is now ' + value + '.');
                user.name = value;
                if (user.media) user.media.name.textContent = value;
                broadcast('namechange', user.name);
                events.emit('namechange', user.name);
                return user.name;
            } else {
                return false;
            }
        };

        // User: validates host key
        user.validateKey = (function () {

            const TIMEOUT = 4000;

            return function () {
                return new Promise(
                    function (resolve, reject) {
                        setTimeout(() => {
                            reject(new Error('Host key validation timed out.'));
                        }, TIMEOUT);
                        window.fetch(room.keyURL + '&channel=' + room.channel + '&key=' + encodeURIComponent(user.key.join('')))
                            .then((res) => {
                                if (res.status === 200) {
                                    broadcast('host', true);
                                    if (user.blocked) socket.join();
                                    resolve(res);
                                } else {
                                    reject();
                                }
                            }, reject);
                    }
                );
            };

        })();

        // Peers: sends message to peers
        function broadcast (type, data, target = 'all') {
            const message = JSON.stringify({
                'type' : type,
                'data': data
            });
            if (target === 'all') {
                const keys = Object.keys(peers);
                for (let i = 0, len = keys.length; i < len; i++) {
                    if (peers[keys[i]].sendChannel.readyState === 'open') {
                        peers[keys[i]].sendChannel.send(message);
                    }
                }
            } else {
                if (target in peers) {
                    if (peers[target].sendChannel.readyState === 'open') {
                        peers[target].sendChannel.send(message);
                    }
                }
            }
        }

        function Peer (config) {

            this.data = {
                pid: config.peer_id,
                name: DEFAULT_USERNAME,
                id: config.user_id,
                offer: config.should_create_offer,
                host: false,
                screensharing: false,
                filter: {}
            };

            this.media = null;
            this.stream = null;

            const pc = new RTCPeerConnection({
                iceServers: ICE_SERVERS
            }, {
                optional: [{ DtlsSrtpKeyAgreement: true }]
            });
            this.pc = pc;

            const sendChannel = pc.createDataChannel('sendChannel');
            sendChannel.addEventListener('open', this.handleSendChannelStatusChange.bind(this));
            sendChannel.addEventListener('close', this.handleSendChannelStatusChange.bind(this));
            this.sendChannel = sendChannel;

            this.fileChannels = {};
            this.incomingChannels = {};

            pc.addEventListener('datachannel', this.handleIncomingChannel.bind(this));
            pc.addEventListener('icecandidate', this.receiveIceCandidate.bind(this));
            pc.addEventListener('negotiationneeded', this.renegotiate.bind(this));
            pc.addEventListener('iceconnectionstatechange', this.handleStateChange.bind(this));
            pc.addEventListener('icegatheringstatechange', this.handleStateChange.bind(this));
            pc.addEventListener('signalingstatechange', this.handleStateChange.bind(this));
            pc.addEventListener('connectionstatechange', this.handleStateChange.bind(this));
            pc.addEventListener('track', this.addTrack.bind(this));

            // Add current tracks to new peers.
            if (user.stream != null) {
                user.stream.getTracks().forEach((track) => {
                    pc.addTrack(track, user.stream);
                });
            }

        }

        Peer.prototype.messageHandles = {};
        Peer.prototype.registerMessageHandler = function (type, callback) {
            if (this.messageHandles.hasOwnProperty(type))
                this.messageHandles[type].push(callback);
            else
                this.messageHandles[type] = [callback];
        };

        Peer.prototype.channelHandles = {};
        Peer.prototype.registerChannelHandler = function (func, callback) {
            this.channelHandles[func] = callback;
        };

        Peer.prototype.send = function (type, data) {
            this.sendChannel.send(JSON.stringify({
                type: type,
                data: data
            }));
        };

        Peer.prototype.name = function () {
            return this.data.name + ID_MARK + this.data.id;
        };

        Peer.prototype.handleSendChannelStatusChange = function (e) {
            if (e.type === 'open') {
                // Exchange names.
                this.send('name', user.name);
                // Send screensharing data
                this.send('screenshare', user.screensharing);
                // Send any filters.
                if (Object.keys(user.filter.saved).length > 0)
                    this.send('filters', user.filters.saved);
                // Host, if host (false means no chat notification).
                if (user.host)
                    this.send('host', false);
            }
        };

        Peer.prototype.handleIncomingChannel = function (e) {
            const channel = e.channel;
            channel.addEventListener('message', this.handleReceiveMessage.bind(this));
            channel.addEventListener('open', this.handleReceiveChannelStatusChange.bind(this));
            channel.addEventListener('close', this.handleReceiveChannelStatusChange.bind(this));
            this.incomingChannels[channel.label] = channel;
        };

        Peer.prototype.handleReceiveMessage = function (e) {
            const channel = e.target;
            if (channel.label === 'sendChannel') {
                const obj = JSON.parse(e.data);
                if (this.messageHandles.hasOwnProperty(obj.type)) {
                    for (let i = 0, len = this.messageHandles[obj.type].length; i < len; i++) {
                        this.messageHandles[obj.type][i].call(this, obj);
                    }
                }
            } else {
                const label = channel.label;
                const split = label.split(':'); // TBD - processing this text is likely performance-heavy, maybe cache?
                if (this.channelHandles.hasOwnProperty(split[0]))
                    this.channelHandles[split[0]].call(this, split, e);
            }
        };

        Peer.prototype.handleReceiveChannelStatusChange = function (e) {
            if (e.type === 'close') {
                delete this.incomingChannels[e.target.label];
            }
        };

        Peer.prototype.receiveIceCandidate = function (e) {
            if (e.candidate) {
                socket.emit('relayICECandidate', {
                    peer_id: this.data.pid,
                    ice_candidate: e.candidate
                });
            }
        };

        Peer.prototype.renegotiate = function (e) {
            if (this.data.offer)
                peerUtils.offer(this.data.pid);
            this.data.offer = true;
        };

        Peer.prototype.handleStateChange = function (e) {
            switch (e.type) {
                case 'iceconnectionstatechange':
                    if (this.pc.iceConnectionState === 'failed')
                        this.pc.restartIce();
                    break;
                default:
                    // const state = this.pc.iceConnectionState + ' ' + this.pc.iceGatheringState + ' ' + this.pc.signalingState + ' ' + this.pc.connectionState;
                    // logChannel(e.type + ' [' +  peerID.slice(0,4) + '] ' + state );
                    break;
            }
        };

        Peer.prototype.addTrack = function (e) {
            ui.messagePrompt.hide();
            this.stream = e.streams[0];
            if (this.media == null) {
                this.media = ui.media.add(this.data.pid);
                this.media.video.addEventListener('loadedmetadata', this.validateMedia.bind(this));
                this.media.fullscreen.addEventListener('click', this.fullscreen.bind(this));
                this.media.mute.addEventListener('click', this.mute.bind(this));
                ui.userlist.update(this.data.pid);
                events.emit('peermedia', this);
            }
            const video = this.media.video;
            if (!video.srcObject || video.srcObject.id !== this.stream.id)
                video.srcObject = this.stream;
        };

        Peer.prototype.validateMedia = function (e) {
            this.media.video.play()
                .catch((error) => {
                    // TBD: Might have issues with multiple simultaneous failed plays.
                    user.permissions.play = false;
                    ui.fullscreenPrompt.prompt('Your browser is blocking incoming callers from connecting. Click or touch anywhere to begin call.');
                    const fse = dom.content__fullscreen;
                    fse.classList.toggle('pointer', true);
                    const removeable = (e) => {
                        ui.resetVideo();
                        user.permissions.play = true;
                        ui.fullscreenPrompt.hide();
                        fse.classList.toggle('pointer', false);
                        fse.removeEventListener('click', removeable);
                    };
                    fse.addEventListener('click', removeable);
                });
        };

        Peer.prototype.fullscreen = function () {
            const mediaElement = this.media.element;
            if (mediaElement.classList.contains('streams__video--fullscreen')) {
                // WIP: Disable video (not audio) all non-fullscreen streams.
                this.media.fullscreen.innerHTML = assets.icons.fullscreen;
                mediaElement.classList.toggle('streams__video--fullscreen', false);
            } else {
                // WIP: Reenable video on all non-fullscreen streams.
                this.media.fullscreen.innerHTML = assets.icons.fullscreenOff;
                mediaElement.classList.toggle('streams__video--fullscreen', true);
            }
        };

        Peer.prototype.mute = function (state = undefined) {
            if (typeof state !== 'boolean')
                this.media.video.muted = !this.media.video.muted;
            else
                this.media.video.muted = state;
            this.media.mute.innerHTML = 
                (this.media.video.muted) ? assets.icons.muted : assets.icons.unmuted;
            ui.userlist.update(this.data.pid);
        };

        // Default chat handlers
        Peer.prototype.registerMessageHandler('chat', function (obj) {
            chat.add(
                obj.data.type, 
                {   pid: this.data.pid,
                    action: (obj.data.action) ? obj.data.action : ''
                }, 
                obj.data.data
            );
        });

        Peer.prototype.registerMessageHandler('filerequest', function (obj) {
            files.send('file', obj.data.hash, this.data.pid);
        });

        Peer.prototype.registerMessageHandler('filereject', function (obj) {
            if (this.fileChannels.hasOwnProperty(obj.data.hash))
                this.fileChannels[obj.data.hash].close();
        });

        Peer.prototype.registerMessageHandler('filedelete', function (obj) {
            const message = chat.messages.find((ele) => {
                return (ele.data.hash && ele.data.hash === obj.data.hash);
            });
            if (message)
                message.deleteFile();
        });

        Peer.prototype.registerMessageHandler('pollcount', function (obj) {
            const message = chat.messages.find((ele) => {
                return (ele.data.hash && ele.data.hash === obj.data.hash);
            });
            if (message)
                message.updatePoll(obj.data.votes);
        });

        Peer.prototype.registerMessageHandler('pollvote', function (obj) {
            chat.poll.vote(obj.data.hash, this.data.pid, obj.data.votes);
            const data = chat.poll.data(obj.data.hash);
            const message = chat.messages.find((ele) => {
                return (ele.data.hash && ele.data.hash === obj.data.hash);
            });
            if (message)
                message.updatePoll(data.votes);
            for (let i = 0, len = data.voters.length; i < len; i++) {
                broadcast('pollcount', {
                    hash: obj.data.hash,
                    votes: data.votes
                }, data.voters[i]);
            }
        });

        Peer.prototype.registerMessageHandler('name', function (obj) {
            this.data.name = obj.data;
            if (this.media) 
                this.media.name.textContent = obj.data + ID_MARK + this.data.id;
            if (!this.data.offer)
                chat.add('notification', { pid: this.data.pid }, 'joined the room.');
            ui.userlist.update(this.data.pid);
        });

        Peer.prototype.registerMessageHandler('namechange', function (obj) {
            if (this.media) 
                this.media.name.textContent = obj.data + ID_MARK + this.data.id;
            chat.add('notification', { pid: this.data.pid }, 'is now ' + obj.data + '.');
            this.data.name = obj.data;
            ui.userlist.update(this.data.pid);
        });

        Peer.prototype.registerMessageHandler('screenshare', function (obj) {
            this.data.screensharing = obj.data;
            if (this.media)
                this.media.element.classList.toggle('streams__video--contain', obj.data);
        });

        Peer.prototype.registerMessageHandler('filters', function (obj) {
            this.data.filter = obj.data;
            if (this.media)
                ui.setElementFilter(this.media.video, obj.data);
        });

        Peer.prototype.registerMessageHandler('lock', function (obj) {
            chat.add('notification', { pid: this.data.pid }, (obj.data) ? 'locked the room.' : 'unlocked the room.');
            ui.controls.lockRoom.set(obj.data);
        });

        Peer.prototype.registerMessageHandler('host', function (obj) {
            // Data parameter informs if host status is silent or not.
            if (obj.data)
                chat.add('notification', { pid: this.data.pid }, 'is now a host.');
            this.data.host = true;
            ui.userlist.update(this.data.pid);
        });

        // Default channel handlers
        Peer.prototype.registerChannelHandler('file', function (params, e) {
            const channel = e.target;
            if (!channel.hasOwnProperty('receivedBuffers'))
                channel.receivedBuffers = [];
            try {
                if (e.data !== 'EOF') {
                    channel.receivedBuffers.push(e.data);
                    channel.message = channel.message ||
                        chat.messages.find((ele) => {
                            return (ele.data.hash && ('' + ele.data.hash) === params[2]);
                        });
                    if (channel.message)
                        channel.message.updateDownload(channel.receivedBuffers);
                } else {
                    const blob = new Blob(channel.receivedBuffers);
                    files.downloadBlob(blob, params[1]);
                    channel.receivedBuffers.length = 0;
                    channel.close();
                }
            } catch (err) {
                ui.messagePrompt.error('File transfer failed: ' + err);
            }
        });

        // Peers: replaces all outgoing streams with current ones 
        peerUtils.setTracks = function () {

            const keys = Object.keys(peers);
            let pid = false, hasAudio = false, hasVideo = false;

            for (let i = 0, len = keys.length; i < len; i++) {
                if (user.stream != null) {

                    pid = keys[i];
                    hasAudio = hasVideo = false;

                    peers[pid].pc.getSenders().map((sender) => {
                        if (sender.track === null) return;
                        if (sender.track.kind === 'audio') hasAudio = true;
                        if (sender.track.kind === 'video') hasVideo = true;
                        sender.replaceTrack(user.stream.getTracks().find((track) => {
                            return track.kind === sender.track.kind;
                        }));
                    });

                    if (!hasVideo) {
                        const videoTrack = user.stream.getTracks().find((track) => {
                            return track.kind === 'video';
                        });
                        if (videoTrack) peers[pid].pc.addTrack(videoTrack, user.stream);
                    }

                    if (!hasAudio) {
                        const audioTrack = user.stream.getTracks().find((track) => {
                            return track.kind === 'audio';
                        });
                        if (audioTrack) peers[pid].pc.addTrack(audioTrack, user.stream);
                    }

                }
            }

        };

        peerUtils.offer = function (pid) {
            peers[pid].pc.createOffer({
                // Legacy parameters. Eventually replace with transceivers?
                offerToReceiveAudio: true,
                offerToReceiveVideo: true
            }).then(
                (localDescription) => {
                    peers[pid].pc.setLocalDescription(localDescription).then(
                        () => {
                            socket.emit('relaySessionDescription', {
                                peer_id: pid,
                                session_description: localDescription
                            });
                        }, (error) => ui.messagePrompt.error
                    );
                }, (error) => ui.messagePrompt.error
            );
        };

        peerUtils.close = function () {
            const keys = Object.keys(peers);
            for (let i = 0, len = keys.length; i < len; i++) {
                peerUtils.remove(keys[i], 'silent');
            }
            // TBD: there's probably more cleanup here ncessary.
        };

        peerUtils.add = (function () {

            function add (config) {

                const keys = Object.keys(peers);

                // Hide information panel and show basic setups if not currently set up.
                ui.infoPanel.toggle(false);
                if (user.stream == null) 
                    ui.controls.call.toggle(true);

                // When the first other person joins the room
                if (keys.length === 0) {
                    ui.messagePrompt.prompt('Waiting for other attendees to enable their camera...');
                    // Check locked room status on connecting with first peer
                    socket.status();
                }

                peers[config.peer_id] = new Peer(config);

                // update usercount
                ui.controls.userCount.update();

                // update chat selector
                chat.selector.update();

                // update userlist
                ui.userlist.add(config.peer_id);

                // call event for addition
                events.emit('peerjoin', peers[config.peer_id]);

            }

            return add;

        })();

        peerUtils.remove = function (pid, type = 'silent') {
            if (pid in peers) {
                if (type === 'kick')
                    chat.add('notification', { pid: pid }, 'has been kicked from the room.');
                else if (type === 'part')
                    chat.add('notification', { pid: pid }, 'has left the room.');
                events.emit('peerremove', peers[pid]);
                ui.media.remove(pid);
                ui.userlist.remove(pid);
                chat.clearUser(pid);
                chat.selector.refresh();
                peers[pid].pc.close();
                peers[pid].sendChannel.close();
                const keys = Object.keys(peers[pid].fileChannels);
                for (let i = 0, len = keys.length; i < len; i++) {
                    peers[pid].fileChannels[keys[i]].close();
                }
                delete peers[pid];

                ui.controls.userCount.update();

                // Hide fullscreen prompt if last person in room.
                if (Object.keys(peers).length === 0) ui.messagePrompt.hide();
            }
        };

        peerUtils.iceCandidate = function (pid, data) {
            const candidate = new RTCIceCandidate(data);
            peers[pid].pc.addIceCandidate(candidate)
                .catch((error) => ui.messagePrompt.error);
        };

        peerUtils.sessionDescription = function (pid, data) {

            const peer = peers[pid].pc;
            const desc = new RTCSessionDescription(data);

            peer.setRemoteDescription(desc).then(
                () => {
                    if (data.type === 'offer') {
                        peer.createAnswer().then(
                            (localDescription) => {
                                peer.setLocalDescription(localDescription).then(
                                    () => {
                                        socket.emit('relaySessionDescription', {
                                            peer_id: pid,
                                            session_description: localDescription
                                        });
                                    }, (error) => ui.messagePrompt.error
                                );
                            }, (error) => ui.messagePrompt.error
                        );
                    }
                }, (error) => ui.messagePrompt.error
            );

        };

        const dpv = (function () {

            function mouseDown (e) {
                if (e.which === 1) { 
                    dpv.grab(e.currentTarget, e.offsetX, e.offsetY);
                    addDocumentListeners();
                }
            }

            function touchStart (e) {
                const rect = e.target.getBoundingClientRect();
                const offsetX = e.targetTouches[0].pageX - rect.left;
                const offsetY = e.targetTouches[0].pageY - rect.top;
                dpv.grab(e.currentTarget, offsetX, offsetY);
                addDocumentListeners();
            }

            function mouseMove (e) { dpv.move(e.clientX, e.clientY); }
            function touchMove (e) { dpv.move(e.touches[0].clientX, e.touches[0].clientY); }
            function endInteraction () { dpv.release(); }

            function addDocumentListeners () {
                document.addEventListener('mousemove', mouseMove);
                document.addEventListener('touchmove', touchMove);
                document.addEventListener('mouseup', endInteraction);
                document.addEventListener('touchend', endInteraction);
            }

            function removeDocumentListeners() {
                document.removeEventListener('mousemove', mouseMove);
                document.removeEventListener('touchmove', touchMove);
                document.removeEventListener('mouseup', endInteraction);
                document.removeEventListener('touchend', endInteraction);
            }

            let active = false;
            let offsetX = 0;
            let offsetY = 0;

            return {
                makeDraggable: function (ele) {
                    ele.addEventListener('mousedown', mouseDown);
                    ele.addEventListener('touchstart', touchStart, 
                        PASSIVE_SUPPORT ? { passive: true } : false);
                },
                grab: function (ele, baseX, baseY) {
                    active = ele;
                    offsetX = baseX;
                    offsetY = baseY;
                    active.style.left = active.offsetLeft + 'px';
                    active.style.top = active.offsetTop + 'px';
                    active.style.right = 'auto';
                    active.style.bottom = 'auto';
                    active.style.cursor = 'grabbing';
                    document.body.style.setProperty('cursor', 'grabbing', 'important');
                },
                move: function (clientX, clientY) {
                    if (!active) return;
                    let desiredX = (clientX - offsetX);
                    let desiredY = (clientY - offsetY);
                    // Top Edge Collision Detection
                    if (desiredX < 0) desiredX = 0;
                    // Left Edge Collision Detection
                    if (desiredY < 0) desiredY = 0;
                    // Right Edge Collision Detection
                    if (desiredX + active.offsetWidth > active.parentElement.offsetWidth)
                        desiredX = active.parentElement.offsetWidth - active.offsetWidth;
                    // Bottom Edge Collision Detection
                    if (desiredY + active.offsetHeight > active.parentElement.offsetHeight)
                        desiredY = active.parentElement.offsetHeight - active.offsetHeight;
                    active.style.left = desiredX + 'px';
                    active.style.top = desiredY + 'px';
                },
                release: function () {
                    if (!active) return;
                    active.style.removeProperty('cursor');
                    document.body.style.cursor = '';
                    removeDocumentListeners();
                    active = false;
                },
                reset: function (ele) {
                    ele.style.left = 'auto';
                    ele.style.top = 'auto';
                    ele.style.right = '0.75em';
                    ele.style.bottom = '4em';
                }
            };

        })();

        // UI: Message prompt popup.
        ui.messagePrompt = {
            prompt: function (message) {
                dom.content__prompt.classList.toggle('content__popup--hidden', false);
                dom.prompt__message.innerHTML = message;
            },
            error: function (message) {
                dom.content__prompt.classList.toggle('content__popup--hidden', false);
                dom.prompt__message.innerHTML = 'Error: ' + message;
                console.error(message);
                // DEBUG
                window.fetch(room.keyURL + '&error=' + encodeURIComponent(message));
            },
            hide: function () {
                dom.content__prompt.classList.toggle('content__popup--hidden', true);
            }
        };

        // UI: Fullscreen Prompt Popup
        ui.fullscreenPrompt = {
            prompt: function (message) {
                ui.messagePrompt.hide();
                dom.content__fullscreen.classList.toggle('content__fullscreen--error', false);
                dom.content__fullscreen.classList.toggle('noclick', false);
                dom.content__fullscreen.classList.toggle('invisible', false);
                dom.fullscreen__panel.classList.toggle('content__popup--hidden', false);
                dom.fullscreen__message.innerHTML = message;
            },
            error: function (message) {
                ui.messagePrompt.hide();
                dom.content__fullscreen.classList.toggle('content__fullscreen--error', true);
                dom.content__fullscreen.classList.toggle('noclick', false);
                dom.content__fullscreen.classList.toggle('invisible', false);
                dom.fullscreen__panel.classList.toggle('content__popup--hidden', false);
                dom.fullscreen__message.innerHTML = message;
            },
            hide: function (message) {
                dom.content__fullscreen.classList.toggle('noclick', true);
                dom.content__fullscreen.classList.toggle('invisible', true);
                dom.fullscreen__panel.classList.toggle('content__popup--hidden', true);
            }
        };

        // UI: Stream Controls Fadeout
        ui.fadeout = (function () {

            const DELAY = 2000;
            // TBD: Check all byClassName for live-ness
            const fadeout = Array.prototype.slice.call(byClassName('overlay__fadeout'));
            let lastReset = Date.now();
            let holds = 0;
            
            function lock () {
                if (!holds++) update();
            }

            function unlock () {
                if (--holds <= 0) {
                    holds = 0;
                    update();
                }
            }
            
            function update () {
                for (let id = 0, len = fadeout.length; id < len; id++) {
                    fadeout[id].classList.toggle('overlay__fadeout', (!holds) ? true : false);
                    lastReset = (holds) ? Date.now() : 0;
                }
            }
            
            function resetFade () {
                const time = Date.now();
                if (!holds && time - lastReset > DELAY) {
                    for (let id = 0, len = fadeout.length; id < len; id++) {
                        fadeout[id].classList.remove('overlay__fadeout');
                    }
                    document.body.offsetWidth;
                    for (let id = 0, len = fadeout.length; id < len; id++) {
                        fadeout[id].classList.add('overlay__fadeout');
                    }
                    lastReset = (lastReset) ? time : 0;
                }
            }

            dom.content.addEventListener('mousemove', resetFade);
            dom.content.addEventListener('touchmove', resetFade, PASSIVE_SUPPORT ? { passive: true } : false);
            dom.background.addEventListener('mousemove', resetFade);
            dom.background.addEventListener('touchmove', resetFade, PASSIVE_SUPPORT ? { passive: true } : false);

            return {
                reset: resetFade,
                lock: lock,
                unlock: unlock
            };

        })();

        ui.controls.userCount = (function () {

            function update () {
                // Number of peers, plus self.
                dom.overlay__usernumber.textContent = (Object.keys(peers).length + 1); 
            }

            dom.overlay__usercount.addEventListener('click', () => { ui.sidebar.swap('userlist'); });

            return { update: update };

        })();

        // UI: Controls: Lock Room
        ui.controls.lockRoom = (function () {

            const TIMEOUT = 500;

            dom.overlay__lockroom.addEventListener('change', function (e) {

                if (room.locked) socket.unlock();
                else socket.lock();

                dom.overlay__lockroom.disabled = true;
                dom.overlay__lockroombutton.style.cursor = 'wait';

                setTimeout(() => {
                    dom.overlay__lockroom.disabled = false;
                    dom.overlay__lockroombutton.style.removeProperty('cursor');
                }, TIMEOUT);

            });

            // Disable by default.
            dom.overlay__lockroom.disabled = true;
        
            return {
                set: (state) => {
                    // Should not trigger event listener.
                    room.locked = state;
                    const icons = dom.overlay__lockroombutton.children;
                    icons[0].classList.toggle('nondisplay', state);
                    icons[1].classList.toggle('nondisplay', !state);
                    dom.lockroombutton__popup.textContent =
                        (state) ? 'Room Locked (Only Host Can Change)'
                            : 'Room Unlocked (Only Host Can Change)';
                }
            };
        })();

        // UI: Controls: Fullscreen
        ui.controls.fullscreen = (function () {

            function toggle () {
                if (document.fullscreenElement) document.exitFullscreen();
                else document.documentElement.requestFullscreen();
            }

            // Remove fullscreen toggle if not available, otherwise activate.
            if (!document.fullscreenEnabled) {
                dom.overlay__fullscreen.parentElement.remove();
                return { toggle: () => false };
            } else {
                dom.overlay__fullscreen.addEventListener('change', toggle);
            }
            
            // Detect fullscreen changes and change icon
            document.addEventListener('fullscreenchange', function (e) {
                const icons = dom.overlay__fullscreenbutton.children;
                if (document.fullscreenElement === null) {
                    icons[0].classList.toggle('nondisplay', false);
                    icons[1].classList.toggle('nondisplay', true);
                } else {
                    icons[0].classList.toggle('nondisplay', true);
                    icons[1].classList.toggle('nondisplay', false);
                }
            });

            return { toggle: toggle };

        })();

        // UI: Stream View / Participant View / Grid View Toggle
        ui.controls.viewMode = (function () {

            function updateView () {

                const state = dom.overlay__streamview.checked;
                room.viewMode = (state) ? 'participant' : 'grid';

                events.emit('viewmode', room.viewMode);

                const icons = dom.overlay__streamviewbutton.children;
                icons[0].classList.toggle('nondisplay', !state);
                icons[1].classList.toggle('nondisplay', state);

                if (user.media) {
                    user.media.element.classList.toggle('streams__uservideo', state);
                    user.media.element.classList.toggle('streams__video', !state);
                    dpv.reset(user.media.element);
                }

            }

            dom.overlay__streamview.addEventListener('change', updateView);
            updateView();

            return {
                toggle: () => {
                    dom.overlay__streamview.checked = !dom.overlay__streamview.checked;
                    updateView();
                }
            };
        
        })();

        // UI: Header Chat Button
        ui.controls.chat = (function () {

            function hide () {
                dom.overlay__chatbutton.classList.toggle('nondisplay', true);
            }

            function show () {
                dom.overlay__chatbutton.classList.toggle('nondisplay', false);
            }

            dom.overlay__chatbutton.addEventListener('click', function () { ui.sidebar.toggle(); } );

            return {
                hide: hide,
                show: show
            };

        })();

        // UI: Microphone
        ui.controls.microphone = (function () {

            function set (state) {
                if (user.stream == null) {
                    ui.controls.call.toggle();
                } else {
                    user.mute(!state);
                    const icons = dom.controls__microphonebutton.children;
                    icons[0].classList.toggle('nondisplay', !state);
                    icons[1].classList.toggle('nondisplay', state);
                }
            }

            function toggle () {
                dom.controls__microphone.checked = !dom.controls__microphone.checked;
                set(dom.controls__microphone.checked);
            }

            dom.controls__microphone.addEventListener('change', function (e) {
                set(dom.controls__microphone.checked);
            });

            return {
                toggle: (state = undefined) => {
                    if (state === undefined) toggle();
                    else if (typeof state === 'boolean') set(state);
                }
            };

        })();

        // UI: Camera
        ui.controls.camera = (function () {

            function set (state) {
                if (user.stream == null) {
                    ui.controls.call.toggle();
                } else {
                    user.dim(!state);
                    const icons = dom.controls__camerabutton.children;
                    icons[0].classList.toggle('nondisplay', !state);
                    icons[1].classList.toggle('nondisplay', state);
                }
            }

            function toggle () {
                dom.controls__camera.checked = !dom.controls__camera.checked;
                set(dom.controls__camera.checked);
            }

            function changeMode (mode = 'camera') {
                const icons = dom.controls__camerabutton.children;
                switch (mode) {
                    case 'screenshare':
                        icons[0].outerHTML = assets.icons.screenshare;
                        icons[1].outerHTML = assets.icons.screenshareOff;
                        break;
                    default:
                        icons[0].outerHTML = assets.icons.camera;
                        icons[1].outerHTML = assets.icons.cameraOff;
                        break;
                }
                const state = dom.controls__camera.checked;
                icons[0].classList.toggle('nondisplay', !state);
                icons[1].classList.toggle('nondisplay', state);
            }

            dom.controls__camera.addEventListener('change', function (e) {
                set(dom.controls__camera.checked);
            });

            return { 
                toggle: (state = undefined) => {
                    if (state === undefined) toggle();
                    else if (typeof state === 'boolean') set(state);
                },
                mode: changeMode
            };

        })();

        // UI: Call Button
        ui.controls.call = (function () {

            function set (state) {
                const button = dom.controls__call;
                button.classList.toggle('controls__hoverable--show', state);
                button.classList.toggle('controls__hoverable--hide', !state);
                if (state) ui.fadeout.lock();
                else ui.fadeout.unlock();
            }

            function toggle () {
                set(!dom.controls__call.classList.contains('controls__hoverable--show'));
            }

            dom.controls__call.addEventListener('click', function (e) {
                if (e.target.tagName.toLowerCase() === 'path' ||
                        e.target.tagName.toLowerCase() === 'button') {
                    if (user.stream == null) toggle();
                    else user.quit();
                }
            });

            return { 
                toggle: (state = undefined) => {
                    if (state === undefined) toggle();
                    else if (typeof state === 'boolean') set(state);
                } 
            };
        })();

        // UI: Name Change Panel
        ui.nameChangePanel = (function () {

            const input = dom.namechange__name;
            const popup = dom.content__namechange;

            function set (state) {
                popup.classList.toggle('content__popup--hidden', !state);
                input.value = user.name;
                if (state) {
                    input.focus();
                    input.setSelectionRange(0, input.value.length);
                } else {
                    input.blur();
                }
            }

            function toggle () {
                set(dom.content__namechange.classList.contains('content__popup--hidden'));
            }

            function register () {
                const complete = user.changeName(input.value.trim());
                if (complete) { 
                    input.value = complete;
                    if (user.media)
                        user.media.name.textContent = user.name + ' ' + SELF_ID;
                }
                input.blur();
                ui.nameChangePanel.toggle();
                ui.userlist.update(user.pid);
            }

            dom.controls__namechange.addEventListener('click', function (e) {
                dom.controls__namechange.classList.toggle('controls__hoverable--show', false);
                toggle();
            });

            dom.namechange__form.addEventListener('submit', register);

            return {
                toggle: (state = undefined) => {
                    if (state === undefined) toggle();
                    else if (typeof state === 'boolean') set(state);
                },
                submit: register
            };

        })();

        // UI: Information Panel
        ui.infoPanel = (function () { 

            function set (state) {
                dom.content__information.classList.toggle('content__popup--hidden', !state);
                if (!state) ui.fadeout.unlock();
                else ui.fadeout.lock();
            }

            function toggle () {
                set(dom.content__information.classList.contains('content__popup--hidden'));
            }

            dom.controls__info.addEventListener('click', toggle);
            dom.information__closer.addEventListener('click', toggle);

            // Display by default.
            set(true);

            return { 
                toggle: (state = undefined) => {
                    if (state === undefined) toggle();
                    else if (typeof state === 'boolean') set(state);
                }
            };

        })();

        // UI: Copy Link Functionality & Animation
        ui.infoPanel.copyLink = (function () {

            const TIMEOUT = 3000;
            const link = dom.shareform__link;

            function selectAll (e) {
                e.target.setSelectionRange(0, e.target.value.length);
            }

            function copyAnimation (e) {
                const button = dom.shareform__copybutton;
                button.classList.toggle('shareform__copybutton--activated', true);
                button.textContent = 'Copied!';

                setTimeout(() => {
                    button.classList.toggle('shareform__copybutton--activated', false);
                    button.textContent = 'Copy';
                }, TIMEOUT);

                // Prompt controls
                if (user.stream == null)
                    ui.controls.call.toggle(true);
            }

            function copy () {
                link.select();
                link.setSelectionRange(0, link.value.length);
                document.execCommand('copy');
                copyAnimation();
            }

            link.addEventListener('click', selectAll);
            link.addEventListener('focus', selectAll);
            link.addEventListener('copy', copyAnimation);
            link.addEventListener('cut', copyAnimation);

            // UI: Copy Link Button functionality
            dom.information__shareform.addEventListener('submit', copy);

            return copy;

        })();

        // WIP: Merge below with ui.infoPanel.validateKey
        // UI: Host Key Input Boxes functionality
        (function () {

            const keycodes = byClassName('keycode__input');

            for (let i = 0, len = keycodes.length; i < len; i++) {

                const shift = function (e) {
                    if (e.ctrlKey || e.altKey) return;
                    if ((e.keyCode >= 48 && e.keyCode <= 90) || e.keyCode === 39) {
                        keycodes[i+1].focus();
                    }
                };

                const unshift = function (e) {
                    if (e.ctrlKey || e.altKey) return;
                    if (e.keyCode === 8 || e.keyCode === 37) {
                        keycodes[i-1].focus();
                    }
                };

                // Select all
                keycodes[i].addEventListener('focus', function (e) {
                    this.setSelectionRange(0, this.value.length);
                });

                // Paste
                keycodes[i].addEventListener('paste', function (e) {
                    const paste = (e.clipboardData || window.clipboardData).getData('text').trim();
                    let lastEntry = i;
                    for (let j = 0; j < paste.length; j++) {
                        if (i + j >= keycodes.length) break;
                        keycodes[i + j].value = paste.charAt(j);
                        lastEntry = i + j;
                    }
                    if (lastEntry + 1 >= keycodes.length) {
                        keycodes[lastEntry].focus();
                    } else {
                        keycodes[++lastEntry].focus();
                    }
                    e.preventDefault();
                });

                // Move to next input
                if (i + 1 !== keycodes.length) {
                    keycodes[i].addEventListener('keyup', shift);
                    keycodes[i].addEventListener('touchend', shift);
                }

                // Backspace
                if (i !== 0) {
                    keycodes[i].addEventListener('keyup', unshift);
                    keycodes[i].addEventListener('touchend', unshift);
                }
            }

        })();

        // WIP: Merge above
        // UI: Host Key Validation
        ui.infoPanel.validateKey = (function () {

            const button = dom.host__validate;
            const keycodes = byClassName('keycode__input');
            const TIMEOUT = 4000;

            function validate () {

                if (button.disabled) return;
                
                user.key.length = 0;
                for (let i = 0, len = keycodes.length; i < len; i++) {
                    user.key.push(keycodes[i].value.toUpperCase());
                }

                button.disabled = true;
                button.style.cursor = 'wait';

                user.validateKey()
                    .then((res) => {
                        button.style.cursor = 'default';
                        chat.add('notification', {}, 'is now a host.');
                        ui.enableHost();
                    }).catch((error) => {
                        setTimeout(() => {
                            button.disabled = false;
                            button.style.cursor = 'pointer';
                        }, TIMEOUT);
                    });
            }

            dom.host__form.addEventListener('submit', validate);
            return validate;

        })();

        // UI: Secret keycode copy functionality
        ui.infoPanel.copyKey = (function () {

            function copy () {
                const temp = createEle('input');
                temp.type = 'text';
                temp.value = (user.key.length) ? encodeURIComponent(user.key.join('')) : '';
                temp.select();
                temp.setSelectionRange(0, temp.value.length);
                document.execCommand('copy');
            }

            function enable () {
                dom.keycode__key.addEventListener('click', copy);
            }

            return { enable: enable };

        })();

        // UI: Host Room Form
        ui.infoPanel.hostRoom = (function () {

            const localDate = (new Date(Date.now() - TIMEZONE_OFFSET)).toISOString().slice(0, 10);

            // UI: Navigate to new page
            function navigate () {
                window.location.href = dom.newroomform__link.href;
            }

            dom.information__newroomform.addEventListener('submit', navigate);

            // UI: Host Room link functionality
            function updateLink () {

                let linkName = encodeURIComponent(dom.newroomform__name.value.trim());
                if (linkName.length === 0) linkName = 'room';

                let linkTime = dom.scheduler__date.valueAsNumber;
                if (linkTime && dom.scheduledroom.checked) {
                    linkTime = ('/' +
                        Math.floor(
                            (   dom.scheduler__date.valueAsNumber +
                                TIMEZONE_OFFSET +
                                dom.scheduler__hour.value * 3600000 +
                                dom.scheduler__minute.value * 60000 +
                                ((dom.scheduler__meridiem.value === 'am') ? 0 : 43200000)
                            ) / 1000
                        )
                    );
                } else {
                    dom.scheduledroom.checked = false;
                    dom.scheduler__date.value = 
                        (new Date(Date.now() - TIMEZONE_OFFSET)).toISOString().slice(0, 10);
                    linkTime = '/0';
                }

                dom.newroomform__link.href = '/' + linkName +
                    ((dom.hostedroom.checked) ? '/hosted' : '/default') +
                    linkTime;
            }

            // Set default schedule time.
            dom.scheduler__date.min = localDate;
            dom.scheduler__date.value = localDate;

            dom.newroomform__name.addEventListener('input', updateLink);
            dom.hostedroom.addEventListener('input', updateLink);
            dom.scheduledroom.addEventListener('input', updateLink);
            dom.scheduler__date.addEventListener('input', updateLink);
            dom.scheduler__hour.addEventListener('input', updateLink);
            dom.scheduler__minute.addEventListener('input', updateLink);
            dom.scheduler__meridiem.addEventListener('input', updateLink);
            
            updateLink();

            return navigate;

        })();

        // UI: Enables host UI configuration.
        ui.enableHost = function () {

            // User is a host.
            user.host = true;

            // Insert current keys.
            const keycodes = byClassName('keycode__input');
            for (let i = 0; i < keycodes.length; i++) {
                keycodes[i].value = user.key[i];
                keycodes[i].disabled = true;
            }

            // Update host entry UI.
            const button = dom.host__validate;
            button.classList.toggle('host__validate--confirmed', true);
            button.textContent = 'room host key';
            button.disabled = true;

            // Enable lock button.
            dom.overlay__lockroom.disabled = false;

            // Display share UI just in case.
            dom.information__shareroom.classList.toggle('nondisplay', false);

            // Hide any blocking messages.
            ui.fullscreenPrompt.hide();

            // Refresh userlist (to populate with controls)
            ui.userlist.refresh();

            // Secret keycode copy.
            ui.infoPanel.copyKey.enable();

        };

        // UI: Basic sidebar functionality
        ui.sidebar = (function () {

            const DEFAULT_TAB = 'chat';
            const tabs = [{
                name: 'chat',
                element: dom.chat,
                button: dom.sidebar__chatbutton,
                callback: () => { chat.resetNotifications(); }
            }, {
                name: 'userlist',
                element: dom.userlist,
                button: dom.sidebar__userlistbutton
            }, {
                name: 'settings',
                element: dom.settings,
                button: dom.sidebar__settingsbutton
            }];
            let active = 'none';

            function getActive () { return active; }

            function toggleButton (tab, state) {
                tab.button.classList.toggle('sidebar__headerbutton--active', state);
                const icons = tab.button.children;
                icons[0].classList.toggle('nondisplay', state);
                icons[1].classList.toggle('nondisplay', !state);
            }

            function cleanse (tab) {
                tab.element.classList.remove('sidebar__tab--left', 'sidebar__tab--right', 'sidebar__tab--animate');
            }

            function swap (goal) {
                if (active === 'none') {
                    // Open from scratch
                    let found = false;
                    for (let i = 0, len = tabs.length; i < len; i++) {
                        cleanse(tabs[i]);
                        if (tabs[i].name === goal) {
                            found = true;
                            toggleButton(tabs[i], true);
                            if (tabs[i].callback) tabs[i].callback();
                        } else {
                            tabs[i].element.classList.add(
                                (!found) ? 'sidebar__tab--left' : 'sidebar__tab--right'
                            );
                        }
                    }
                    active = goal;
                    open();
                } else if (active === goal || goal === 'none') {
                    // If tab was already open.
                    for (let i = 0, len = tabs.length; i < len; i++) {
                        if (tabs[i].name === active) {
                            toggleButton(tabs[i], false);
                            break;
                        }
                    }
                    close();
                } else {
                    // Swapping tabs.
                    let found = false;
                    for (let i = 0, len = tabs.length; i < len; i++) {
                        cleanse(tabs[i]);
                        if (tabs[i].name === goal) {
                            found = true;
                            toggleButton(tabs[i], true);
                            tabs[i].element.classList.add('sidebar__tab--animate');
                            if (tabs[i].callback) tabs[i].callback();
                        } else if (tabs[i].name === active) {
                            toggleButton(tabs[i], false);
                            tabs[i].element.classList.add('sidebar__tab--animate',
                                (!found) ? 'sidebar__tab--left' : 'sidebar__tab--right'
                            );
                        } else {
                            tabs[i].element.classList.add(
                                (!found) ? 'sidebar__tab--left' : 'sidebar__tab--right'
                            );
                        }
                    }
                    active = goal;
                }
            }

            function toggle () {
                if (active === 'none') swap(DEFAULT_TAB);
                else swap(active);
            }

            function open () {
                dom.sidebar.classList.toggle('sidebar--open', true);
            }

            function close () {
                dom.sidebar.classList.toggle('sidebar--open', false);
                dom.sidebar.classList.toggle('sidebar--big', false);
                active = 'none';
            }

            function shrink () {
                dom.sidebar.classList.toggle('sidebar--shrunk', true);
            }

            function unshrink () {
                dom.sidebar.classList.toggle('sidebar--shrunk', false);
            }

            dom.sidebar__expandedbutton.addEventListener('click', () => { swap(DEFAULT_TAB); });
            
            tabs.forEach((tab) => {
                tab.button.addEventListener('click', () => { swap(tab.name); });
            });

            return {
                toggle: toggle,
                open: open,
                close: close,
                swap: swap,
                shrink: shrink,
                unshrink: unshrink,
                active: getActive
            };

        })();

        // UI: Light/Dark Mode
        ui.settings.toggleDarkMode = (function () {

            function set (state) {
                dom.darkmode.checked = state;
                document.documentElement.setAttribute('data-user-color-scheme', (state) ? 'dark' : 'light');
            }

            function setValue (state) {
                if (typeof state === 'boolean') {
                    set(state);
                    dom.darkmode.value = (state) ? 'dark' : 'light';
                } else {
                    set(dom.darkmode.checked);
                    dom.darkmode.value = (dom.darkmode.checked) ? 'dark' : 'light';
                }
            }

            // Initialize dark or light mode depending browser configuration or autosaved forms.
            if (dom.darkmode.value === 'dark') {
                set(true);
            } else if (dom.darkmode.value === 'light') {
                set(false);
            } else {
                let setting = document.documentElement.getAttribute('data-user-color-scheme');
                if (setting === null) {
                    setting = getComputedStyle(document.documentElement).getPropertyValue('--color-mode');
                    setting = (setting.length) ? setting.replace('\'', '').trim() : setting;
                }
                if (setting === 'light') set(false);
                else set(true);
            }

            dom.darkmode.addEventListener('change', setValue);

            return (state = undefined) => {
                if (state === undefined) state = !dom.darkmode.checked;
                if (typeof state === 'boolean') setValue(state);
            };

        })();

        // UI: Mirror Local Video
        ui.settings.toggleMirror = (function () {

            function set (state = undefined) {
                if (typeof state !== 'boolean') state = dom.mirror.checked;
                else dom.mirror.checked = state;
                if (user.media !== null)
                    user.media.element.classList.toggle('streams__video--mirrored', state);
            }

            dom.mirror.addEventListener('change', set);
            // No need to set default as video is not enabled by default.

            return (state = undefined) => {
                if (state === undefined) set(!dom.mirror.checked);
                else if (typeof state === 'boolean') set(state);
            };

        })();

        // UI: Show User Video Toggle
        ui.settings.toggleShowSelf = (function () {

            function set (state = undefined) {
                if (typeof state !== 'boolean') state = dom.showself.checked;
                else dom.showself.checked = state;
                if (user.media && user.media.element) {
                    const mediaElement = user.media.element;
                    mediaElement.parentElement.prepend(mediaElement);
                    if (dom.showself.checked) {
                        mediaElement.classList.toggle('nondisplay', false);
                        if (dom.overlay__streamview.checked)
                            mediaElement.classList.toggle('streams__uservideo', true);
                        else
                            mediaElement.classList.toggle('streams__video', true);
                    } else {
                        mediaElement.classList.toggle('streams__uservideo', false);
                        mediaElement.classList.toggle('streams__video', false);
                        mediaElement.classList.toggle('nondisplay', true);
                    }
                }
            }

            dom.showself.addEventListener('change', set);

            return (state = undefined) => {
                if (state === undefined) set(!dom.showself.checked);
                else if (typeof state === 'boolean') set(state);
            };
        })();

        ui.settings.toggleFadeout = (function () {

            function set (state = undefined) {
                if (typeof state !== 'boolean') state = dom.fadeout.checked;
                else dom.fadeout.checked = state;

                if (dom.fadeout.checked) {
                    ui.fadeout.lock();
                } else {
                    ui.fadeout.unlock();                
                }
            }

            dom.fadeout.addEventListener('change', set);
            
            // Initialize
            if (dom.fadeout.checked) ui.fadeout.lock();

            return (state = undefined) => {
                if (state === undefined) set(!dom.fadeout.checked);
                else if (typeof state === 'boolean') set(state);
            };

        })();

        // UI: Hidden Sidebar when Closed
        ui.settings.toggleHiddenChat = (function () {

            function set (state = undefined) {
                if (typeof state !== 'boolean') state = dom.hiddenchat.checked;
                else dom.hiddenchat.checked = state;

                if (dom.hiddenchat.checked) {
                    ui.sidebar.shrink();
                    ui.controls.chat.show();
                } else {
                    ui.sidebar.unshrink();
                    ui.controls.chat.hide();
                }
            }

            dom.hiddenchat.addEventListener('change', set);
            set(); // Set default.

            return (state = undefined) => {
                if (state === undefined) set(!dom.hiddenchat.checked);
                else if (typeof state === 'boolean') set(state);
            };

        })();

        // UI: Utility function to set filters for any element (element, filters).
        ui.setElementFilter = function (element, filters) {
            let filterString = '';
            Object.keys(filters).sort().reverse().forEach((filter) => {
                filterString += filter + '(' + filters[filter] + ui.getFilterUnits(filter) + ') ';
            });
            element.style.filter = filterString;
        };

        // UI: Utility function to get the units for specific filter types (filter type).
        ui.getFilterUnits = function (id) {
            switch (id) {
                case 'hue-rotate':
                    return 'deg';
                default:
                    return '%';
            }
        };

        // UI: Filter Settings
        (function () {
            
            function changeFilter (e) {
                // Change specific filter.
                user.filter.active[e.target.id] = e.target.value;

                // Change element
                if (user.media !== null)
                    ui.setElementFilter(user.media.video, user.filter.active);

                // Change value in settings
                e.target.parentElement.querySelector('.settings__value').textContent = 
                    e.target.value + ui.getFilterUnits(e.target.id);

                // Undisable apply button
                dom.applyfilters.disabled = false;
            }

            dom.brightness.addEventListener('input', changeFilter);
            dom.contrast.addEventListener('input', changeFilter);
            dom.saturate.addEventListener('input', changeFilter);
            dom.sepia.addEventListener('input', changeFilter);
            dom['hue-rotate'].addEventListener('input', changeFilter);

            // Save Filters.
            dom.applyfilters.addEventListener('click', function (e) {
                if (Object.keys(user.filter.active).length !== 0) {
                    broadcast('filters', user.filter.active);
                    for (const filter in user.filter.active) {
                        if (user.filter.active.hasOwnProperty(filter))
                            user.filter.saved[filter] = user.filter.active[filter] + '';
                    }
                    dom.applyfilters.disabled = true;
                }
            });

        })();

        ui.userlist = (function () {

            const userlist = dom.userlist__list;
            const entries = [];

            function UserEntry (pid) {

                this.pid = pid;
                this.self = (pid === user.pid);
                this.data = (this.self) ? user : peers[pid].data;
                this.dom = {};
                this.media = this.findCorrespondingMediaElement();

                this.dom.wrapper = createEle('div');
                this.dom.wrapper.className = 'userlist__user';
                this.dom.wrapper.innerHTML = (this.data.host) ? assets.icons.host : assets.icons.person;
                
                this.hover = this.hover.bind(this);
                this.hoverOff = this.hoverOff.bind(this);
                this.dom.wrapper.addEventListener('mouseenter', this.hover);
                this.dom.wrapper.addEventListener('mouseleave', this.hoverOff);

                this.dom.name = createEle('span');
                this.dom.name.className = 'user__name';
                this.dom.name.textContent = this.data.name;
                this.dom.name.title = this.data.name;

                this.dom.id = createEle('span');
                this.dom.id.className = 'user__id';
                this.dom.id.textContent = (this.self) ? SELF_ID : ((ID_MARK) + this.data.id);

                this.dom.wrapper.appendChild(this.dom.name);
                this.dom.wrapper.appendChild(this.dom.id);
                
                this.generateControls(pid);
            }

            UserEntry.prototype.generateControls = function (pid) { 
                // TBD: Don't regenerate controls, update them.
                if (!this.self) {
                    if (this.dom.controls) 
                        this.dom.controls.remove();

                    this.dom.controls = createEle('div');
                    this.dom.controls.className = 'user__controls';
                    
                    if (peers[pid].media) {
                        this.dom.mute = createEle('button');
                        this.dom.mute.className = 'user__button user__mute';
                        this.dom.mute.innerHTML = (peers[pid].media.video.muted) ? assets.icons.muted : assets.icons.unmuted;
                        this.dom.mute.appendChild(this.generateHover((peers[pid].media.video.muted) ? 'Unmute' : 'Mute'));
                        this.dom.mute.addEventListener('click', peers[pid].mute.bind(peers[pid]));
                        this.dom.controls.appendChild(this.dom.mute);
                    }

                    if (user.host) {
                        this.dom.kick = createEle('button');
                        this.dom.kick.className = 'user__button user__button--admin user__kick';
                        this.dom.kick.innerHTML = assets.icons.close;
                        this.dom.kick.appendChild(this.generateHover('Kick'));
                        this.dom.kick.appendChild(this.generateAuthorizedIcon());
                        this.dom.kick.addEventListener('click', this.kick.bind(this));    
                        this.dom.controls.appendChild(this.dom.kick);
                    }
                    
                    this.dom.wrapper.appendChild(this.dom.controls);
                }
            };

            UserEntry.prototype.generateHover = function (text) {
                const hover = createEle('div');
                hover.className = 'userbutton__hover';
                hover.textContent = text;
                return hover;
            };
            
            UserEntry.prototype.generateAuthorizedIcon = function () {
                const host = createEle('div');
                host.className = 'userbutton__authorized';
                host.innerHTML = assets.icons.authorized;
                return host;
            }

            UserEntry.prototype.getElement = function () {
                return this.dom.wrapper;
            };

            UserEntry.prototype.remove = function () {
                // this.dom.wrapper.removeEventListener('mouseenter', this.hover);
                // this.dom.wrapper.removeEventListener('mouseleave', this.hoverOff);
                // if (this.dom.mute) this.dom.mute.removeEventListener('click', peers[pid].mute.bind(peers[pid]));
                // if (this.dom.kick) this.dom.kick.removeEventListener('click', this.kick);
                this.dom.wrapper.remove();
            };

            UserEntry.prototype.update = function () {
                this.self = (this.pid === user.pid);
                this.data = (this.self) ? user : peers[this.pid].data;
                this.media = this.findCorrespondingMediaElement();

                // User icon
                this.dom.wrapper.children[0].outerHTML = (this.data.host) ? assets.icons.host : assets.icons.person;
                
                // Name
                this.dom.name.textContent = this.data.name;

                // Update controls
                this.generateControls(this.pid);
            };

            UserEntry.prototype.findCorrespondingMediaElement = function () {
                if (this.self && user.media) 
                    return user.media.element;
                else if (!this.self && peers[this.pid].media) 
                    return peers[this.pid].media.element;
                else return null;
            };

            UserEntry.prototype.hover = function () {
                if (this.media === null)
                    this.media = this.findCorrespondingMediaElement();
                if (this.media !== null)
                    this.media.classList.toggle('streams__video--hover', true);
            };

            UserEntry.prototype.hoverOff = function () {
                if (this.media === null)
                    this.media = this.findCorrespondingMediaElement();
                if (this.media !== null)
                    this.media.classList.toggle('streams__video--hover', false);
            };

            UserEntry.prototype.kick = function () {
                socket.kick(this.pid);
            };

            function add (pid) {
                // Prevent duplicates.
                for (let i = 0, len = entries.length; i < len; i++) {
                    if (entries[i].pid === pid) return false;
                }
                if (user.pid === pid || peers.hasOwnProperty(pid)) {
                    const entry = new UserEntry(pid);
                    entries.push(entry);
                    userlist.appendChild(entry.getElement());
                    return true;
                } else {
                    return false;
                }
            }

            function remove (pid) {
                // Cannot remove self.
                for (let i = 1, len = entries.length; i < len; i++) {
                    if (entries[i].pid === pid) {
                        entries[i].remove();
                        entries.splice(i--, 1);
                        len--;
                    }
                }
            }

            function update (pid = undefined) {

                if (pid === undefined) {
                    refresh();
                    return;
                }
            
                for (let i = 0, len = entries.length; i < len; i++) {
                    if (entries[i].pid === pid) {
                        entries[i].update();
                        return;
                    }
                }

                add(pid);
            }

            function refresh () {

                // TBD This checks if connected to socket already (ie. adding self).
                if (entries.length === 0) return;

                // Update self
                entries[0].update();

                // Update others
                const keys = Object.keys(peers);
                const len = keys.length;
                const assignments = Math.min(len, entries.length - 1);
                let alterations = len - (entries.length - 1);

                // Assignments
                let i = 0;
                while (i < assignments) {
                    entries[i + 1].pid = keys[i];
                    entries[i + 1].update();

                    i++;
                }

                // Alterations (additions or removals)
                if (alterations > 0) {
                    while (i < len) {
                        add(keys[i]);
                        i++;
                    }
                } else {
                    const start = i;
                    while (i < entries.length) {
                        entries[i + 1].remove();
                        i++;
                    }
                    entries.splice(start);
                }

            }

            return {
                add: add,
                remove: remove,
                update: update,
                refresh: refresh
            };

        })();

        // UI: Plays all video. Hopeful reset.
        ui.resetVideo = function () {
            const videos = document.getElementsByTagName('video');
            for (let i = 0; i < videos.length; i++) {
                videos[i].play();
            }
        };

        ui.enableCallControls = function () {

            // If nobody in the room and not blocked from room, show an awaiting message.
            if (Object.keys(peers).length === 0 && !user.blocked)
                ui.messagePrompt.prompt('Waiting for other attendees to join...');

            // Hopeful video reset
            ui.resetVideo();

            // Hide prompt if autoplay was blocked earlier
            if (!user.permissions.play) {
                ui.fullscreenPrompt.hide();
                user.permissions.play = true;
            }

            // Replace call button with end call button.
            dom.popup__call.parentElement.textContent = 'End Call';
            const controlButton = dom.controls__call;
            controlButton.classList.toggle('controls__call--oncall', true);
            controlButton.children[0].classList.toggle('nondisplay', true);
            controlButton.children[1].classList.toggle('nondisplay', false);

            // Remove forced show/hide on hoverable button popups & hide locks on audio/video.
            const shown = byClassName('controls__hoverable--show');
            const hidden = byClassName('controls__hoverable--hide');
            const locked = byClassName('controls__locked');

            // Reverse order because Collection length changes with removal.
            while (shown.length > 0) {
                shown[0].classList.remove('controls__hoverable--show');
            }
            while (hidden.length > 0) {
                hidden[0].classList.remove('controls__hoverable--hide');
            }
            for (let i = 0; i < locked.length; i++) {
                locked[i].classList.add('nondisplay');
            }

            // Show participant mode button
            dom.overlay__streamviewbutton.classList.toggle('nondisplay', false);

            // Enable camera and microphone.
            ui.controls.microphone.toggle(true);
            ui.controls.camera.toggle(true);

            // Force username change prompt if name is still default.
            if (user.name === DEFAULT_USERNAME) {
                dom.controls__namechange.classList.toggle('controls__hoverable--show', true);
            }

            // Update media devices.
            navigator.mediaDevices.addEventListener('devicechange', ui.devices.update);
            ui.devices.update();
        };

        ui.media = (function () {

            function addUser () {

                let media = {};

                const mediaElement = createEle('div');
                mediaElement.id = 'streams__uservideo';
                mediaElement.classList.add(
                    (dom.showself.checked) ? 'streams__video' : 'nondisplay'
                );
                mediaElement.classList.toggle('streams__video--contain', user.screensharing);
                mediaElement.classList.toggle('streams__video--mirrored', dom.mirror.checked);
                dpv.makeDraggable(mediaElement);
                media.element = mediaElement;

                const video = createEle('video');
                video.autoplay = true;
                video.muted = true;
                video.controls = false;
                video.srcObject = user.stream;
                if (Object.keys(user.filter).length > 0)
                    ui.setElementFilter(video, user.filter);
                media.video = video;

                const toolbar = createEle('div');
                toolbar.className = 'streams__toolbar';
                toolbar.innerHTML = assets.icons.draggable;

                const username = createEle('div');
                username.className = 'streams__username streams__username--self';
                username.textContent = user.name + ' '  + SELF_ID;
                media.name = username;

                toolbar.appendChild(username);
                mediaElement.appendChild(video);
                mediaElement.appendChild(toolbar);

                dom.streams.prepend(mediaElement);

                return media;

            }

            function addPeer (pid) {
                
                const peer = peers[pid];
                let media = {};

                const mediaElement = createEle('div');
                mediaElement.className = 'streams__video';
                mediaElement.classList.toggle('streams__video--contain', peer.data.screensharing);
                media.element = mediaElement;

                const video = createEle('video');
                video.autoplay = true;
                video.controls = false;
                if (Object.keys(peer.data.filter).length > 0)
                    ui.setElementFilter(video, peer.data.filter);
                media.video = video;

                const toolbar = createEle('div');
                toolbar.className = 'streams__toolbar';
                toolbar.innerHTML = assets.icons.person;

                const username = createEle('div');
                username.className = 'streams__username';
                username.textContent = peer.name();
                media.name = username;

                const fullscreen = createEle('button');
                fullscreen.className = 'streams__toolbarbutton streams__fullscreen';
                fullscreen.innerHTML = assets.icons.fullscreen;
                media.fullscreen = fullscreen;

                const mute = createEle('button');
                mute.className = 'streams__toolbarbutton streams__mute';
                mute.innerHTML = assets.icons.unmuted;
                media.mute = mute;

                toolbar.appendChild(username);
                toolbar.appendChild(fullscreen);
                toolbar.appendChild(mute);

                mediaElement.appendChild(video);
                mediaElement.appendChild(toolbar);

                dom.streams.appendChild(mediaElement);

                return media;

            }

            function remove (pid) {
                if (pid in peers) {
                    if (peers[pid].media) {
                        peers[pid].media.element.remove();
                        peers[pid].media = null;
                    }
                }
            }

            return {
                self: addUser,
                add: addPeer,
                remove: remove
            };

        })();

        ui.devices = (function () {

            const registeredIcons = {};
            let waitingForPermissions = false;

            function registerIcon (icon, asset) {
                registeredIcons[icon] = asset;
            }

            // Default icons
            registerIcon('camera', assets.icons.camera);
            registerIcon('screenshare', assets.icons.screenshare);
            registerIcon('microphone', assets.icons.microphone);
            registerIcon('nomic', assets.icons.nomic);
            registerIcon('play', assets.icons.play);

            function generateDeviceElement (icons, name, active = false) {
                const wrapper = createEle('button');
                wrapper.className = 'device__wrapper';
                wrapper.classList.toggle('device__wrapper--active', active);

                const dicons = createEle('div');
                dicons.className = 'device__icons';
                let iconList = '';
                for (let i = 0; i < icons.length; i++) {
                    if (registeredIcons.hasOwnProperty(icons[i])) {
                        iconList += registeredIcons[icons[i]];
                    }
                }
                dicons.innerHTML = iconList;

                const dname = createEle('div');
                dname.className = 'device__name';
                dname.textContent = name;

                wrapper.appendChild(dicons);
                wrapper.appendChild(dname);

                return wrapper;
            }

            function deviceInitialize (stream) {
                if (!stream) return;
                ui.enableCallControls();
                peerUtils.setTracks();
            }

            function deviceChange (stream) {
                if (!stream) return;
                ui.devices.update();
                peerUtils.setTracks();
            }

            function update () {

                // Add devices to mute and camera feed buttons.
                let videoInputs = [], audioInputs = [];
                let screenshare = !MOBILE_AGENT  && navigator.mediaDevices.getDisplayMedia; // Someday, replace this with an actual feature support check.
    
                navigator.mediaDevices.enumerateDevices().then((arr) => {
    
                    // Derive list of inputs, if available.
                    for (let i = 0, len = arr.length; i < len; i++) {
                        // if (arr[i].deviceId === 'default' || arr[i].deviceId === 'communications') continue;
                        switch (arr[i].kind) {
                            case 'videoinput':
                                videoInputs.push(arr[i]);
                                break;
                            case 'audioinput':
                                audioInputs.push(arr[i]);
                                break;
                        }
                    }
    
                    const audioWrapper = dom.popup__microphone;
                    const videoWrapper = dom.popup__camera;
                    audioWrapper.innerHTML = videoWrapper.innerHTML = '';
    
                    // Audio Inputs
                    if (user.permissions.audio) {
                        audioInputs.forEach((ele) => {
                            const active = user.activeDevices.some((device) => device.deviceId === ele.deviceId);
                            const device = (active) ?
                                generateDeviceElement(['play'], ele.label, true) :
                                generateDeviceElement(['microphone'], ele.label);
                            if (!active) {
                                device.addEventListener('click', function (e) {
                                    setupLocalMedia({ video: false, audio: { deviceId: { exact: ele.deviceId } } })
                                        .then(deviceChange);
                                });
                            }
                            audioWrapper.appendChild(device);
                        });
                    } else if (audioInputs.length > 0) {
                        const device = generateDeviceElement(['microphone'], 'Enable Microphone');
                        device.addEventListener('click', function (e) {
                            setupLocalMedia({ video: false, audio: true })
                                .then(deviceChange);
                        });
                        audioWrapper.appendChild(device);
                    } else {
                        audioWrapper.textContent = 'No devices available.';
                    }
    
                    // Video Inputs
                    if (user.permissions.video) {
                        videoInputs.forEach((ele) => {
                            const active = user.activeDevices.some((device) => device.deviceId === ele.deviceId);
                            const device = (active) ?
                                generateDeviceElement(['play'], ele.label, true) :
                                generateDeviceElement(['camera'], ele.label);
                            if (!active) {
                                device.addEventListener('click', function (e) {
                                    setupLocalMedia({ video: { deviceId: { exact: ele.deviceId } }, audio: false })
                                        .then(deviceChange);
                                });
                            }
                            videoWrapper.appendChild(device);
                        });
                    } else if (videoInputs.length > 0) {
                        const device = generateDeviceElement(['camera'], 'Enable Camera');
                        device.addEventListener('click', function (e) {
                            setupLocalMedia({ video: true, audio: false })
                                .then(deviceChange);
                        });
                        videoWrapper.appendChild(device);
                    } else {
                        videoWrapper.textContent = 'No devices available.';
                    }
    
                    // Screenshare
                    if (screenshare) {
                        const device = generateDeviceElement(['screenshare'], 'Screenshare');
                        device.addEventListener('click', function (e) {
                            setupDisplayMedia()
                                .then(deviceChange);
                        });
                        videoWrapper.appendChild(device);
                    }
    
                });

            }

            function setupLocalMedia (config) {

                return new Promise((resolve, reject) => {
                
                    // Prevent double clicks.
                    if (waitingForPermissions)
                        return resolve(false);
                    waitingForPermissions = true;

                    navigator.mediaDevices.getUserMedia({
                        audio: config.audio,
                        video: config.video
                    }).then((stream) => {

                        waitingForPermissions = false;
                        if (user.screensharing && config.video) {
                            user.screensharing = false;
                            broadcast('screenshare', false);
                            ui.controls.camera.mode('camera');
                        }

                        if (user.stream != null) {
                            if (config.audio) {
                                user.permissions.audio = true;
                                user.stream.getAudioTracks().forEach((track) => {
                                    track.stop();
                                    user.stream.removeTrack(track);
                                });
                                stream.getAudioTracks().forEach((track) => {
                                    user.stream.addTrack(track);
                                });
                            }
                            if (config.video) {
                                user.permissions.video = true;
                                user.stream.getVideoTracks().forEach((track) => {
                                    track.stop();
                                    user.stream.removeTrack(track);
                                });
                                stream.getVideoTracks().forEach((track) => {
                                    user.stream.addTrack(track);
                                });
                                user.media.element.classList.toggle('streams__video--contain', false);
                            }
                        } else {
                            user.permissions.audio = config.audio;
                            user.permissions.video = config.video;
                            user.stream = stream;
                            user.media = ui.media.self();
                        }

                        events.emit('media', 'user');
                        user.activeDevices = user.stream.getTracks().map(de => de.getSettings());
                        resolve(user.stream);

                    }).catch((error) => ui.messagePrompt.error);
                
                });
                
            }

            function setupDisplayMedia () {

                return new Promise((resolve, reject) => {
                
                    // Prevent double clicks.
                    if (waitingForPermissions)
                        return resolve(false);
                    waitingForPermissions = true;

                    navigator.mediaDevices.getDisplayMedia({
                        audio: false, // Display Audio WIP
                        video: true
                    }).then((stream) => {

                        waitingForPermissions = false;
                        user.permissions.screenshare = true;
                        user.screensharing = true;
                        broadcast('screenshare', true);
                        ui.controls.camera.mode('screenshare');

                        if (user.stream != null) {
                            user.stream.getVideoTracks().forEach((track) => {
                                track.stop();
                                user.stream.removeTrack(track);
                            });
                            stream.getVideoTracks().forEach((track) => {
                                user.stream.addTrack(track);
                            });
                            user.media.element.classList.toggle('streams__video--contain', true);
                        } else {
                            user.stream = stream;
                            user.media = ui.media.self();
                        }
                        
                        events.emit('media', 'display');
                        user.activeDevices = user.stream.getTracks().map(de => de.getSettings());
                        resolve(user.stream);

                    }).catch((error) => ui.messagePrompt.error);
                    
                });

            }

            // Then finally, initialize.
            (function () {

                if (navigator.mediaDevices == null) {
                    ui.messagePrompt.prompt('This browser is not supported.<br>iOS users: Safari is the only browser with access to core features.');
                    dom.popup__call.textContent = 'No devices available.';
                    return;
                } 

                let camera = false, microphone = false;
                let screenshare = !MOBILE_AGENT && navigator.mediaDevices.getDisplayMedia;

                navigator.mediaDevices.enumerateDevices().then((arr) => {

                    for (let i = 0, len = arr.length; i < len; i++) {
                        switch (arr[i].kind) {
                            case 'videoinput':
                                camera = true;
                                break;
                            case 'audioinput':
                                microphone = true;
                                break;
                        }
                    }

                    if (!camera && !microphone && !screenshare)
                        dom.popup__call.textContent = 'No devices available.';

                    if (camera && microphone) {
                        let ele = generateDeviceElement(['camera', 'microphone'], 'camera + microphone');
                        ele.addEventListener('click', function (e) {
                            setupLocalMedia({ audio: true, video: { facingMode: 'user' } })
                                .then(deviceInitialize);
                        });
                        dom.popup__call.appendChild(ele);
                    } else if (camera) {
                        let ele = generateDeviceElement(['camera', 'nomic'], 'camera (no microphone)');
                        ele.addEventListener('click', function (e) {
                            setupLocalMedia({ audio: false, video: true })
                                .then(deviceInitialize);
                        });
                        dom.popup__call.appendChild(ele);
                    }

                    if (screenshare && microphone) {
                        let ele = generateDeviceElement(['screenshare', 'microphone'], 'screenshare + microphone');
                        ele.addEventListener('click', function (e) {
                            setupLocalMedia({ audio: true, video: false }).then(() => {
                                setupDisplayMedia()
                                    .then(deviceInitialize);
                            });
                        });
                        dom.popup__call.appendChild(ele);
                    } else if (screenshare) {
                        let ele = generateDeviceElement(['screenshare', 'nomic'], 'screenshare (no microphone)');
                        ele.addEventListener('click', function (e) {
                            setupDisplayMedia()
                                .then(deviceInitialize);
                        });
                        dom.popup__call.appendChild(ele);
                    }

                    if (microphone) {
                        let ele = generateDeviceElement(['microphone'], 'microphone only');
                        ele.addEventListener('click', function (e) {
                            setupLocalMedia({ audio: true, video: false })
                                .then(deviceInitialize);
                        });
                        dom.popup__call.appendChild(ele);
                    }

                });


            })();

            return {
                update: update
            };

        })();

        // UI: Keyboard shortcuts
        (function () {

            function keyDown (e) {
                if (!(e.keyCode in keysPressed)) {
                    switch (e.target.tagName.toLowerCase()) {
                        case 'input':
                        case 'textarea':
                            break;
                        default:
                            if (e.ctrlKey || e.altKey || e.shiftKey) break;
                            switch (e.keyCode) {
                                case 32: // spacebar
                                    if (user.stream != null)
                                        ui.controls.microphone.toggle();
                                    keysPressed[e.keyCode] = true;
                                    break;
                            }
                            break;
                    }
                }
            }

            function keyUp (e) {
                if (keysPressed[e.keyCode]) delete keysPressed[e.keyCode];
                switch (e.target.tagName.toLowerCase()) {
                    case 'input':
                    case 'textarea':
                        break;
                    default:
                        if (e.ctrlKey || e.altKey || e.shiftKey) break;
                        switch (e.keyCode) {
                            case 67: // c
                                ui.controls.camera.toggle();
                                break;
                            case 70: // f
                                ui.controls.fullscreen.toggle();
                                break;
                            case 73: // i
                                ui.infoPanel.toggle();
                                break;
                            case 32: // spacebar
                                if (user.stream != null)
                                    ui.controls.microphone.toggle();
                                break;
                            case 77: // m
                                ui.controls.microphone.toggle();
                                break;
                            case 78: // n
                                ui.nameChangePanel.toggle();
                                break;
                            case 83: // s
                                ui.sidebar.toggle();
                                break;
                        }
                        break;
                }
            }

            document.addEventListener('keydown', keyDown);
            document.addEventListener('keyup', keyUp);

        })();

        // Chat: Snarkdown (https://github.com/developit/snarkdown) used.
        let snarkdown = function (text) {

            // Added to prevent XSS.
            text = (text + '')
                .replace(/&/g, '&amp;')
                .replace(/\\#/g, '&#35;')
                .replace(/"/g, '&quot;')
                .replace(/\\\*/g, '&#42;')
                .replace(/'/g, '&#39;')
                .replace(/</g, '&lt;');

            const TAGS = {
                '' : ['<em>','</em>'],
                '*' : ['<strong>','</strong>'],
                '~' : ['<s>','</s>'],
                '\n' : ['<br />'],
                ' ' : ['<br />'],
                '-': ['<hr />']
            };

            function outdent (str) {
                return str.replace(RegExp('^'+(str.match(/^(\t| )+/) || '')[0], 'gm'), '');
            }

            function encodeAttr (str) {
                return (str+'').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
            }

            /** Parse Markdown into an HTML String. */
            function parse (md, prevLinks) {

                let tokenizer = /((?:^|\n+)(?:\n---+|\* \*(?: \*)+)\n)|(?:^``` *(\w*)\n([\s\S]*?)\n```$)|((?:(?:^|\n+)(?:\t|  {2,}).+)+\n*)|((?:(?:^|\n)([>*+-]|\d+\.)\s+.*)+)|(?:\!\[([^\]]*?)\]\(([^\)]+?)\))|(\[)|(\](?:\(([^\)]+?)\))?)|(?:(?:^|\n+)([^\s].*)\n(\-{3,}|={3,})(?:\n+|$))|(?:(?:^|\n+)(#{1,6})\s*(.+)(?:\n+|$))|(?:`([^`].*?)`)|(  \n\n*|\n{2,}|__|\*\*|[_*]|~~)/gm,
                    context = [],
                    out = '',
                    links = prevLinks || {},
                    last = 0,
                    chunk, prev, token, inner, t;

                function tag (token) {
                    if (token === '_') return '_';
                    var desc = TAGS[token[1] || ''],
                        end = context[context.length - 1] == token;
                    if (!desc) return token;
                    if (!desc[1]) return desc[0];
                    context[end ? 'pop' : 'push'](token);
                    return desc[end|0];
                }

                function flush () {
                    let str = '';
                    while (context.length) str += tag(context[context.length - 1]);
                    return str;
                }

                /*
                md = md.replace(/^\[(.+?)\]:\s*(.+)$/gm, (s, name, url) => {
                    links[name.toLowerCase()] = url;
                    return '';
                }).replace(/^\n+|\n+$/g, '');
                */

                while ((token = tokenizer.exec(md))) {
                    prev = md.substring(last, token.index);
                    last = tokenizer.lastIndex;
                    chunk = token[0];
                    if (prev.match(/[^\\](\\\\)*\\$/)) {
                        // escaped
                    }
                    // Code/Indent blocks:
                    else if (token[3] || token[4]) {
                        chunk = '<pre class="code">'+outdent(encodeAttr(token[3] || token[4]).replace(/^\n+|\n+$/g, '')) + '</pre>';
                    }
                    // > Quotes, -* lists:
                    else if (token[6]) {
                        t = token[6];
                        if (t.match(/\./)) {
                            token[5] = token[5].replace(/^\d+/gm, '');
                        }
                        inner = parse(outdent(token[5].replace(/^\s*[>*+.-]/gm, '')));
                        if (t === '>') t = 'blockquote';
                        else {
                            t = t.match(/\./) ? 'ol' : 'ul';
                            inner = inner.replace(/^(.*)(\n|$)/gm, '<li>$1</li>');
                        }
                        chunk = '<' + t + '>' + inner + '</' + t + '>';
                    }
                    /* Disabled to prevent XSS.
                    // Images:
                    else if (token[8]) {
                        chunk = `<img src="${encodeAttr(token[8])}" alt="${encodeAttr(token[7])}">`;
                    }
                    // Links:
                    else if (token[10]) {
                        out = out.replace('<a>', `<a href="${encodeAttr(token[11] || links[prev.toLowerCase()])}">`);
                        chunk = flush() + '</a>';
                    }
                    else if (token[9]) {
                        chunk = '<a>';
                    }
                    */
                    // Headings:
                    else if (token[12] || token[14]) {
                        t = 'h' + (token[14] ? token[14].length : (token[13][0] === '=' ? 1 : 2));
                        chunk = '<'+t+'>' + parse(token[12] || token[15], links) + '</'+t+'>';
                    }
                    // `code`:
                    else if (token[16]) {
                        chunk = '<code>' + encodeAttr(token[16]) + '</code>';
                    }
                    // Inline formatting: *em*, **strong** & friends
                    else if (token[17] || token[1]) {
                        chunk = tag(token[17] || '--');
                    }
                    out += prev;
                    out += chunk;
                }

                return (out + md.substring(last) + flush()).trim();
            }

            return (parse)(text);
        };

        let ChatMessage = (function () {

            const CONSOLIDATION_WINDOW = 60000;

            function ChatMessage (type, identity, data) {

                this.type = type;
                this.identity = identity;
                this.data = data;
                this.time = new Date();
                this.dom = {};

                if (identity.hasOwnProperty('pid')) {
                    this.identity.name = peers[identity.pid].data.name;
                    this.identity.id = peers[identity.pid].data.id;
                } else if (identity.hasOwnProperty('name') && identity.hasOwnProperty('id')) {
                    this.identity.pid = undefined;
                    this.identity.name = identity.name;
                    this.identity.id = identity.id;
                } else {
                    this.identity.pid = user.pid;
                    this.identity.name = user.name;
                    this.identity.id = SELF_ID;
                }

                if (!identity.hasOwnProperty('action'))
                    this.identity.action = '';

                this.dom.wrapper = createEle('div');
                this.dom.wrapper.className = 'chat__entry chat__' + type.replace(/\s+/g, '');

                // Header
                if (chat.messages.length > 0) {
                    const lastMessage = chat.messages[chat.messages.length - 1];
                    if (this.time.getTime() - lastMessage.time.getTime() > CONSOLIDATION_WINDOW ||
                        !this.sameUser(lastMessage)) {
                        this.dom.wrapper.appendChild(this.generateHeader());
                    }
                } else {
                    this.dom.wrapper.appendChild(this.generateHeader());
                }

                // Content
                this.dom.content = createEle('div');
                this.dom.content.className = 'message__content';
                if (this.typeGenerators.hasOwnProperty(this.type))
                    this.typeGenerators[this.type].call(this, this, this.dom.content, data);
                else
                    this.typeGenerators['default'].call(this, this, this.dom.content, data);

                this.dom.wrapper.appendChild(this.dom.content);
            }

            ChatMessage.prototype.typeGenerators = {};
            ChatMessage.prototype.registerType = function (type, callback) {
                this.typeGenerators[type] = callback;
            };

            // Default handlers
            ChatMessage.prototype.textGenerator = function (message, ele, data) {
                ele.textContent = data;
            };

            ChatMessage.prototype.fileGenerator = function (message, ele, data) {
                ele.appendChild(this.generateFile());
            };

            ChatMessage.prototype.pollGenerator = function (message, ele, data) {
                ele.appendChild(this.generatePoll());
            };

            ChatMessage.prototype.snarkdownGenerator = function (message, ele, data) {
                ele.innerHTML = snarkdown(data);
            };

            ChatMessage.prototype.registerType('default', ChatMessage.prototype.textGenerator);
            ChatMessage.prototype.registerType('notification', ChatMessage.prototype.textGenerator);
            ChatMessage.prototype.registerType('message', ChatMessage.prototype.snarkdownGenerator);
            ChatMessage.prototype.registerType('file', ChatMessage.prototype.fileGenerator);
            ChatMessage.prototype.registerType('poll', ChatMessage.prototype.pollGenerator);

            ChatMessage.prototype.prepositions = {
                'from': 'from',
                'to': 'to'
            };

            ChatMessage.prototype.getElement = function () {
                return this.dom.wrapper;
            };

            ChatMessage.prototype.remove = function () {
                this.dom.wrapper.remove();
            };

            ChatMessage.prototype.sameUser = function (message) {
                if ((message.identity.pid &&
                        message.identity.pid === this.identity.pid) ||
                    (message.identity.name && message.identity.id &&
                        message.identity.name === this.identity.name &&
                        message.identity.id === this.identity.id)) return true;
                return false;
            };

            ChatMessage.prototype.generateHeader = function () {

                const header = this.dom.header = {};

                header.wrapper = createEle('div');
                header.wrapper.className = 'message__info';

                const user = createEle('div');
                user.className = 'message__user';

                let preposition = null;
                if (this.identity.action.length !== 0 && 
                    this.prepositions.hasOwnProperty(this.identity.action)) {
                    preposition = createEle('span');
                    preposition.className = 'message__preposition';
                    preposition.textContent = this.prepositions[this.identity.action];
                }
                
                header.name = createEle('span');
                header.name.className = 'message__name';
                header.name.textContent = this.identity.name;

                if (this.identity.pid !== user.pid) {
                    header.name.classList.toggle('message__name--selectable', true);
                    header.name.addEventListener('click', this.selectUser.bind(this));

                    this.removeSelectableName = function () {
                        header.name.classList.toggle('message__name--selectable', false);
                        header.name.removeEventListener('click', this.selectUser.bind(this)); // This might not work.
                    };
                }
                
                header.id = createEle('span');
                header.id.className = 'message__id';
                header.id.textContent = ID_MARK + this.identity.id;

                header.time = createEle('time');
                header.time.className = 'message__time';
                header.time.textContent = 
                    this.time.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' }).toLocaleLowerCase();

                if (preposition !== null)
                    user.appendChild(preposition);
                user.appendChild(header.name);
                user.appendChild(header.id);
                header.wrapper.appendChild(user);
                header.wrapper.appendChild(header.time);
                return header.wrapper;
            };

            ChatMessage.prototype.generateFile = function () {

                const data = this.data;
                const file = this.dom.file = {};

                file.wrapper = createEle('div');
                file.wrapper.className = 'message__file';

                if (!('name' in data) || !('size' in data) || !('type' in data) || !('hash' in data)) {
                    file.wrapper.textContent = 'Received invalid file';
                    return file.wrapper;
                }

                const icon = createEle('div');
                icon.className = 'filepreview__icon';
                icon.innerHTML = files.getFileIcon(data.type);

                const info = createEle('div');
                info.className = 'filepreview__info';

                file.name = createEle('span');
                file.name.className = 'filepreview__name';
                file.name.textContent = data.name;

                file.size = createEle('span');
                file.size.className = 'filepreview__size';
                file.size.textContent = data.sizeString = files.convertToFileSize(data.size);

                file.download = createEle('button');
                file.download.type = 'button';
                file.download.className = 'filepreview__action';
                file.download.innerHTML = assets.icons.download;
                file.download.addEventListener('click', this.downloadFile.bind(this));
                
                file.delete = false;
                if (this.identity.pid === user.pid) {
                    file.delete = createEle('button');
                    file.delete.type = 'button';
                    file.delete.className = 'filepreview__action';
                    file.delete.innerHTML = assets.icons.delete;
                    file.delete.addEventListener('click', this.deleteFile.bind(this));
                }

                file.percentage = createEle('div');
                file.percentage.className = 'filepreview__percentage';

                info.appendChild(file.name);
                info.appendChild(file.size);
                file.wrapper.appendChild(icon);
                file.wrapper.appendChild(info);
                file.wrapper.appendChild(file.download);
                if (file.delete) file.wrapper.appendChild(file.delete);
                file.wrapper.appendChild(file.percentage);

                return file.wrapper;
            };

            ChatMessage.prototype.downloadFile = function () {
                if (this.identity.pid === user.pid) {
                    // Download local file.
                    files.download(this.data.hash);
                } else {
                    if (peers[this.identity.pid] &&
                        peers[this.identity.pid].fileChannels &&
                        peers[this.identity.pid].fileChannels[this.data.hash]) {
                        // Request download cancellation if ongoing.
                        broadcast('filereject', {
                            hash: this.data.hash
                        }, this.identity.pid);
                        this.dom.file.download.innerHTML = assets.icons.download;
                    } else if (this.identity.pid != undefined) {
                        // Request file.
                        broadcast('filerequest', {
                            hash: this.data.hash
                        }, this.identity.pid);
                        this.dom.file.download.disabled = true;
                    }
                }
            };

            ChatMessage.prototype.deleteFile = function () { 

                // Disable download button.
                const dl = this.dom.file.download;
                dl.innerHTML = 'Removed';
                dl.disabled = true;
                dl.removeEventListener('click', this.downloadFile);

                // Cleanup for self-hosted files.
                if (this.identity.pid === user.pid) {

                    // Close all on-going downlods
                    const keys = Object.keys(peers);
                    for (let i = 0, len = keys.length; i < len; i++) {
                        if (this.data.hash in peers[keys[i]].fileChannels) {
                            peers[keys[i]].fileChannels[this.data.hash].close();
                        }
                    }

                    // Delete local file.
                    files.remove(this.data.hash);

                    // Broadcast to others that file is no longer accessible.
                    broadcast('filedelete', { hash: this.data.hash });

                    // Remove delete button.
                    let del = this.dom.file.delete;
                    del.remove();
                    del = false;
                
                }

            };

            ChatMessage.prototype.updateDownload = function (download) {

                if (download === 'delete') {
                    this.deleteFile();
                    return;
                }

                const dom = this.dom.file;
                const data = this.data;
                let size = download.length * MAX_MESS_SIZE;

                if (size >= data.size) {
                    // Download completed.
                    dom.download.innerHTML = assets.icons.download;
                    size = data.size;
                } else if (download.length === 1) {
                    // Download started.
                    dom.download.innerHTML = assets.icons.close;
                    dom.download.disabled = false;
                }

                dom.percentage.style.width = Math.round((size/data.size)*100) + '%';
                dom.size.textContent = files.convertToFileSize(size) + ' / ' + data.sizeString;
            };

            ChatMessage.prototype.generatePoll = function () {

                const data = this.data;
                const poll = this.dom.poll = {};

                poll.wrapper = createEle('div');
                poll.wrapper.className = 'message__poll';

                // Check for invalid data.
                if (!('hash' in data) || !('options' in data) || !('multi' in data)) {
                    poll.wrapper.textContent = 'Received invalid poll';
                    return poll.wrapper;
                }

                poll.entries = [];
                for (let i = 0, len = data.options.length; i < len; i++) {
                    const label = createEle('label');
                    label.className = 'poll__label';

                    const selector = createEle('input');
                    selector.type = (data.multi) ? 'checkbox' : 'radio';
                    selector.className = 'poll__selector';
                    selector.name = 'poll--' + data.hash;
                    selector.addEventListener('change', this.pollSelection.bind(this));

                    const text = createEle('span');
                    text.className = 'poll__text';
                    text.textContent = data.options[i];

                    const count = createEle('span');
                    count.className = 'poll__count';

                    const percentage = createEle('div');
                    percentage.className = 'poll__percentage';

                    label.appendChild(selector);
                    label.appendChild(text);
                    label.appendChild(count);
                    label.appendChild(percentage);
                    poll.wrapper.appendChild(label);

                    poll.entries.push({
                        wrapper: label,
                        selector: selector,
                        count: count,
                        percent: percentage,
                        label: data.options[i]
                    });
                }

                poll.action = createEle('button');
                poll.action.type = 'button';
                poll.action.className = 'poll__action';
                poll.action.textContent = 'Vote';
                poll.action.disabled = true;
                poll.action.addEventListener('click', this.pollVote.bind(this));

                poll.wrapper.appendChild(poll.action);

                return poll.wrapper;
            };

            ChatMessage.prototype.pollSelection = function () {
                const entries = this.dom.poll.entries;
                let checked = null, contains = null, changed = false, mincheck = false;
                for (let i = 0, len = entries.length; i < len; i++) {
                    checked = entries[i].selector.checked;
                    contains = entries[i].wrapper.classList.contains('poll__label--voted');
                    if (checked !== contains) {
                        changed = true;
                    }
                    if (!mincheck && checked) mincheck = true;
                }
                if (mincheck && changed)
                    this.dom.poll.action.disabled = false;
                else
                    this.dom.poll.action.disabled = true;
            };

            ChatMessage.prototype.pollVote = function () {
                const entries = this.dom.poll.entries;
                let votes = [];
                for (let i = 0, len = entries.length; i < len; i++) {
                    if (entries[i].selector.checked) {
                        votes.push(entries[i].label);
                        entries[i].wrapper.classList.toggle('poll__label--voted', true);
                    } else {
                        entries[i].wrapper.classList.toggle('poll__label--voted', false);
                    }
                }
                if (this.identity.pid === user.pid) {
                    chat.poll.vote(this.data.hash, user.pid, votes);
                    const data = chat.poll.data(this.data.hash);
                    this.updatePoll(data.votes);
                    for (let i = 0, len = data.voters.length; i < len; i++) {
                        broadcast('pollcount', {
                            hash: this.data.hash,
                            votes: data.votes
                        }, data.voters[i]);
                    }
                } else {
                    broadcast('pollvote', {
                        hash: this.data.hash,
                        votes: votes
                    }, this.identity.pid);
                }
                this.dom.poll.action.textContent = 'Change Vote';
                this.dom.poll.action.disabled = true;
            };

            ChatMessage.prototype.updatePoll = function (votes) {
                
                const entries = this.dom.poll.entries;

                if (votes === 'delete') {
                    for (let i = 0, len = entries.length; i < len; i++) {
                        entries[i].selector.disabled = true;
                    }
                    this.dom.poll.action.disabled = true;
                    this.dom.poll.action.textContent = 'Poll Closed';
                    return;
                }

                const labels = Object.keys(votes);

                // Sum all votes together.
                let sum = 0;
                for (let i = 0, len = labels.length; i < len; i++) {
                    sum += votes[labels[i]];
                }

                for (let i = 0, len = entries.length; i < len; i++) {
                    if (votes.hasOwnProperty(entries[i].label)) {
                        const percent = Math.round((votes[entries[i].label]/sum)*100) + '%';
                        entries[i].count.textContent = votes[entries[i].label];
                        entries[i].count.title = percent;
                        entries[i].percent.style.width = percent;
                    } else {
                        entries[i].count.textContent = '';
                        entries[i].percent.style.width = '0%';
                    }
                }
            };
            
            ChatMessage.prototype.selectUser = function (e) {
                chat.selector.change(this.identity.pid);
            };

            return ChatMessage;

        })();

        chat.addNotification = function () {
            dom.chatbutton__notifications.textContent =
                (++chat.notifications > 99) ? '!' : chat.notifications;
        };

        chat.resetNotifications = function () {
            chat.notifications = 0;
            dom.chatbutton__notifications.textContent = '';
        };

        chat.scrollToBottom = function () {
            dom.chat__content.scrollTop = dom.chat__content.scrollHeight;
        };

        // Chat: Add Chat Message
        chat.add = (function () {
            function add (type, identity, data) {
                const message = new ChatMessage(type, identity, data);
                chat.messages.push(message);
                dom.chat__content.appendChild(message.getElement());
                chat.scrollToBottom();
                if (ui.sidebar.active() !== 'chat')
                    chat.addNotification();
                events.emit('chat', message);
            }
            return add;
        })();

        // Chat: Remove all instances of user from chat, and clean up unique messages.
        chat.clearUser = function (pid) {
            chat.messages.forEach((e) => {
                if (e.identity.pid && e.identity.pid === pid) {
                    if (e.removeSelectableName)
                        e.removeSelectableName();
                    if (e.type === 'file')
                        e.updateDownload('delete');
                    if (e.type === 'poll')
                        e.updatePoll('delete');
                }
            });
        };

        // Chat: Chat send functionality
        chat.send = function (type, data) {
            // Get selector value.
            const target = chat.selector.get();
            // Send message.
            broadcast('chat', {
                type: type,
                action: (target === 'all') ? '' : 'from',
                data: data
            }, target);
            // Add message to chat.
            chat.add(type, (target === 'all') ? { } : {
                pid: target,
                action: 'to'
            }, data);
        };

        // Chat: Chat selector
        chat.selector = (function () {

            const selector = dom.chat__selector;

            function get () {
                return selector.options[selector.selectedIndex].value;
            }

            function change (pid) {
                let found = false;
                for (let i = 0, len = selector.options.length; i < len; i++) {
                    if (selector.options[i].value === pid) {
                        selector.selectedIndex = found;
                        return;
                    }
                }
            }

            function update (pid = undefined) {

                if (pid === undefined) {
                    refresh();
                    return;
                }

                for (let i = 1, len = selector.options.length; i < len; i++) {
                    if (selector.options[i].value === pid) {
                        if (peers.hasOwnProperty(pid)) {
                            selector.options[i].textContent = peers[pid].name();
                        } else {
                            refresh();
                        }
                        return;
                    }
                }
            }

            function refresh () {

                const prevpid = selector.options[selector.selectedIndex].value;
                const keys = Object.keys(peers);

                const assignments = Math.min(keys.length, selector.options.length - 1);
                let alterations = keys.length - (selector.options.length - 1);
                
                // Assignments
                let peer = 0, desiredName = 0, i = 0, found = false;
                while (i < assignments) {

                    peer = peers[keys[i]];
                    desiredName = peer.name();
                    selector.options[i + 1].value = keys[i];

                    if (selector.options[i + 1].textContent !== desiredName)
                        selector.options[i + 1].textContent = desiredName;
                        
                    if (prevpid === keys[i]) {
                        selector.selectedIndex = i + 1;
                        found = true;
                    }

                    i++;
                }

                // Alterations (additions or removals)
                if (alterations > 0) {
                    while (alterations--) {
                            peer = peers[keys[i]];
                            desiredName = peer.name();
                            
                            const option = createEle('option');
                            option.value = keys[i];
                            option.textContent = desiredName;
                            selector.appendChild(option);

                            if (prevpid === keys[i]) {
                                selector.selectedIndex = selector.options.length - 1;
                                found = true;
                            }

                            i++;
                    }
                } else {
                    while (alterations++) {
                        selector.removeChild(selector.lastChild);
                    }
                }

                // Reset value if previous selection was removed.
                if (!found) selector.selectedIndex = 0;

            }

            return {
                change: change,
                refresh: refresh,
                update: update,
                get: get
            };

        })();    

        // Chat: Chat input functionality
        chat.input = (function () {

            // UI: Emoji
            const EMOJI = ['😀', '😁', '😂', '🤣', '😃', '😄', '😅', '😆', '😉', '😊', '😋', '😎', '😍', '😘', '😗', '😙', '😚', '☺', '🙂', '🤗', '🤔', '😐', '😑', '😶', '🙄', '😏', '😣', '😥', '😮', '🤐', '😯', '😪', '😫', '😴', '😌', '🤓', '😛', '😜', '😝', '🤤', '😒', '😓', '😔', '😕', '🙃', '🤑', '😲', '☹', '🙁', '😖', '😞', '😟', '😤', '😢', '😭', '😦', '😧', '😨', '😩', '😬', '😰', '😱', '😳', '😵', '😡', '😠', '😇', '🤠', '🤡', '🤥', '😷', '🤒', '🤕', '🤢', '🤧', '😈', '👿', '👹', '👺', '💀', '☠', '👻', '👽', '👾', '🤖', '💩', '😺', '😸', '😹', '😻', '😼', '😽', '🙀', '😿', '😾', '🙈', '🙉', '🙊', '👦', '👦🏻', '👦🏼', '👦🏽', '👦🏾', '👦🏿', '👧', '👧🏻', '👧🏼', '👧🏽', '👧🏾', '👧🏿', '👨', '👨🏻', '👨🏼', '👨🏽', '👨🏾', '👨🏿', '👩', '👩🏻', '👩🏼', '👩🏽', '👩🏾', '👩🏿', '👴', '👴🏻', '👴🏼', '👴🏽', '👴🏾', '👴🏿', '👵', '👵🏻', '👵🏼', '👵🏽', '👵🏾', '👵🏿', '👶', '👶🏻', '👶🏼', '👶🏽', '👶🏾', '👶🏿', '👼', '👼🏻', '👼🏼', '👼🏽', '👼🏾', '👼🏿', '👮', '👮🏻', '👮🏼', '👮🏽', '👮🏾', '👮🏿', '🕵', '🕵🏻', '🕵🏼', '🕵🏽', '🕵🏾', '🕵🏿', '💂', '💂🏻', '💂🏼', '💂🏽', '💂🏾', '💂🏿', '👷', '👷🏻', '👷🏼', '👷🏽', '👷🏾', '👷🏿', '👳', '👳🏻', '👳🏼', '👳🏽', '👳🏾', '👳🏿', '👱', '👱🏻', '👱🏼', '👱🏽', '👱🏾', '👱🏿', '🎅', '🎅🏻', '🎅🏼', '🎅🏽', '🎅🏾', '🎅🏿', '🤶', '🤶🏻', '🤶🏼', '🤶🏽', '🤶🏾', '🤶🏿', '👸', '👸🏻', '👸🏼', '👸🏽', '👸🏾', '👸🏿', '🤴', '🤴🏻', '🤴🏼', '🤴🏽', '🤴🏾', '🤴🏿', '👰', '👰🏻', '👰🏼', '👰🏽', '👰🏾', '👰🏿', '🤵', '🤵🏻', '🤵🏼', '🤵🏽', '🤵🏾', '🤵🏿', '🤰', '🤰🏻', '🤰🏼', '🤰🏽', '🤰🏾', '🤰🏿', '👲', '👲🏻', '👲🏼', '👲🏽', '👲🏾', '👲🏿', '🙍', '🙍🏻', '🙍🏼', '🙍🏽', '🙍🏾', '🙍🏿', '🙎', '🙎🏻', '🙎🏼', '🙎🏽', '🙎🏾', '🙎🏿', '🙅', '🙅🏻', '🙅🏼', '🙅🏽', '🙅🏾', '🙅🏿', '🙆', '🙆🏻', '🙆🏼', '🙆🏽', '🙆🏾', '🙆🏿', '💁', '💁🏻', '💁🏼', '💁🏽', '💁🏾', '💁🏿', '🙋', '🙋🏻', '🙋🏼', '🙋🏽', '🙋🏾', '🙋🏿', '🙇', '🙇🏻', '🙇🏼', '🙇🏽', '🙇🏾', '🙇🏿', '🤦', '🤦🏻', '🤦🏼', '🤦🏽', '🤦🏾', '🤦🏿', '🤷', '🤷🏻', '🤷🏼', '🤷🏽', '🤷🏾', '🤷🏿', '💆', '💆🏻', '💆🏼', '💆🏽', '💆🏾', '💆🏿', '💇', '💇🏻', '💇🏼', '💇🏽', '💇🏾', '💇🏿', '🚶', '🚶🏻', '🚶🏼', '🚶🏽', '🚶🏾', '🚶🏿', '🏃', '🏃🏻', '🏃🏼', '🏃🏽', '🏃🏾', '🏃🏿', '💃', '💃🏻', '💃🏼', '💃🏽', '💃🏾', '💃🏿', '🕺', '🕺🏻', '🕺🏼', '🕺🏽', '🕺🏾', '🕺🏿', '👯', '🕴', '🗣', '👤', '👥', '🤺', '🏇', '⛷', '🏂', '🏌', '🏄', '🏄🏻', '🏄🏼', '🏄🏽', '🏄🏾', '🏄🏿', '🚣', '🚣🏻', '🚣🏼', '🚣🏽', '🚣🏾', '🚣🏿', '🏊', '🏊🏻', '🏊🏼', '🏊🏽', '🏊🏾', '🏊🏿', '⛹', '⛹🏻', '⛹🏼', '⛹🏽', '⛹🏾', '⛹🏿', '🏋', '🏋🏻', '🏋🏼', '🏋🏽', '🏋🏾', '🏋🏿', '🚴', '🚴🏻', '🚴🏼', '🚴🏽', '🚴🏾', '🚴🏿', '🚵', '🚵🏻', '🚵🏼', '🚵🏽', '🚵🏾', '🚵🏿', '🏎', '🏍', '🤸', '🤸🏻', '🤸🏼', '🤸🏽', '🤸🏾', '🤸🏿', '🤼', '🤼🏻', '🤼🏼', '🤼🏽', '🤼🏾', '🤼🏿', '🤽', '🤽🏻', '🤽🏼', '🤽🏽', '🤽🏾', '🤽🏿', '🤾', '🤾🏻', '🤾🏼', '🤾🏽', '🤾🏾', '🤾🏿', '🤹', '🤹🏻', '🤹🏼', '🤹🏽', '🤹🏾', '🤹🏿', '👫', '👬', '👭', '💏', '👩‍❤️‍💋‍👨', '👨‍❤️‍💋‍👨', '👩‍❤️‍💋‍👩', '💑', '👩‍❤️‍👨', '👨‍❤️‍👨', '👩‍❤️‍👩', '👪', '👨‍👩‍👦', '👨‍👩‍👧', '👨‍👩‍👧‍👦', '👨‍👩‍👦‍👦', '👨‍👩‍👧‍👧', '👨‍👨‍👦', '👨‍👨‍👧', '👨‍👨‍👧‍👦', '👨‍👨‍👦‍👦', '👨‍👨‍👧‍👧', '👩‍👩‍👦', '👩‍👩‍👧', '👩‍👩‍👧‍👦', '👩‍👩‍👦‍👦', '👩‍👩‍👧‍👧', '🏻', '🏼', '🏽', '🏾', '🏿', '💪', '💪🏻', '💪🏼', '💪🏽', '💪🏾', '💪🏿', '🤳', '🤳🏻', '🤳🏼', '🤳🏽', '🤳🏾', '🤳🏿', '👈', '👈🏻', '👈🏼', '👈🏽', '👈🏾', '👈🏿', '👉', '👉🏻', '👉🏼', '👉🏽', '👉🏾', '👉🏿', '☝', '☝🏻', '☝🏼', '☝🏽', '☝🏾', '☝🏿', '👆', '👆🏻', '👆🏼', '👆🏽', '👆🏾', '👆🏿', '🖕', '🖕🏻', '🖕🏼', '🖕🏽', '🖕🏾', '🖕🏿', '👇', '👇🏻', '👇🏼', '👇🏽', '👇🏾', '👇🏿', '✌', '✌🏻', '✌🏼', '✌🏽', '✌🏾', '✌🏿', '🤞', '🤞🏻', '🤞🏼', '🤞🏽', '🤞🏾', '🤞🏿', '🖖', '🖖🏻', '🖖🏼', '🖖🏽', '🖖🏾', '🖖🏿', '🤘', '🤘🏻', '🤘🏼', '🤘🏽', '🤘🏾', '🤘🏿', '🤙', '🤙🏻', '🤙🏼', '🤙🏽', '🤙🏾', '🤙🏿', '🖐', '🖐🏻', '🖐🏼', '🖐🏽', '🖐🏾', '🖐🏿', '✋', '✋🏻', '✋🏼', '✋🏽', '✋🏾', '✋🏿', '👌', '👌🏻', '👌🏼', '👌🏽', '👌🏾', '👌🏿', '👍', '👍🏻', '👍🏼', '👍🏽', '👍🏾', '👍🏿', '👎', '👎🏻', '👎🏼', '👎🏽', '👎🏾', '👎🏿', '✊', '✊🏻', '✊🏼', '✊🏽', '✊🏾', '✊🏿', '👊', '👊🏻', '👊🏼', '👊🏽', '👊🏾', '👊🏿', '🤛', '🤛🏻', '🤛🏼', '🤛🏽', '🤛🏾', '🤛🏿', '🤜', '🤜🏻', '🤜🏼', '🤜🏽', '🤜🏾', '🤜🏿', '🤚', '🤚🏻', '🤚🏼', '🤚🏽', '🤚🏾', '🤚🏿', '👋', '👋🏻', '👋🏼', '👋🏽', '👋🏾', '👋🏿', '👏', '👏🏻', '👏🏼', '👏🏽', '👏🏾', '👏🏿', '✍', '✍🏻', '✍🏼', '✍🏽', '✍🏾', '✍🏿', '👐', '👐🏻', '👐🏼', '👐🏽', '👐🏾', '👐🏿', '🙌', '🙌🏻', '🙌🏼', '🙌🏽', '🙌🏾', '🙌🏿', '🙏', '🙏🏻', '🙏🏼', '🙏🏽', '🙏🏾', '🙏🏿', '🤝', '🤝🏻', '🤝🏼', '🤝🏽', '🤝🏾', '🤝🏿', '💅', '💅🏻', '💅🏼', '💅🏽', '💅🏾', '💅🏿', '👂', '👂🏻', '👂🏼', '👂🏽', '👂🏾', '👂🏿', '👃', '👃🏻', '👃🏼', '👃🏽', '👃🏾', '👃🏿', '👣', '👀', '👁', '👁‍🗨', '👅', '👄', '💋', '💘', '❤', '💓', '💔', '💕', '💖', '💗', '💙', '💚', '💛', '💜', '🖤', '💝', '💞', '💟', '❣', '💌', '💤', '💢', '💣', '💥', '💦', '💨', '💫', '💬', '🗨', '🗯', '💭', '🕳', '👓', '🕶', '👔', '👕', '👖', '👗', '👘', '👙', '👚', '👛', '👜', '👝', '🛍', '🎒', '👞', '👟', '👠', '👡', '👢', '👑', '👒', '🎩', '🎓', '⛑', '📿', '💄', '💍', '💎', '🐵', '🐒', '🦍', '🐶', '🐕', '🐩', '🐺', '🦊', '🐱', '🐈', '🦁', '🐯', '🐅', '🐆', '🐴', '🐎', '🦌', '🦄', '🐮', '🐂', '🐃', '🐄', '🐷', '🐖', '🐗', '🐽', '🐏', '🐑', '🐐', '🐪', '🐫', '🐘', '🦏', '🐭', '🐁', '🐀', '🐹', '🐰', '🐇', '🐿', '🦇', '🐻', '🐨', '🐼', '🐾', '🦃', '🐔', '🐓', '🐣', '🐤', '🐥', '🐦', '🐧', '🕊', '🦅', '🦆', '🦉', '🐸', '🐊', '🐢', '🦎', '🐍', '🐲', '🐉', '🐳', '🐋', '🐬', '🐟', '🐠', '🐡', '🦈', '🐙', '🐚', '🦀', '🦐', '🦑', '🦋', '🐌', '🐛', '🐜', '🐝', '🐞', '🕷', '🕸', '🦂', '💐', '🌸', '💮', '🏵', '🌹', '🥀', '🌺', '🌻', '🌼', '🌷', '🌱', '🌲', '🌳', '🌴', '🌵', '🌾', '🌿', '☘', '🍀', '🍁', '🍂', '🍃', '🍇', '🍈', '🍉', '🍊', '🍋', '🍌', '🍍', '🍎', '🍏', '🍐', '🍑', '🍒', '🍓', '🥝', '🍅', '🥑', '🍆', '🥔', '🥕', '🌽', '🌶', '🥒', '🍄', '🥜', '🌰', '🍞', '🥐', '🥖', '🥞', '🧀', '🍖', '🍗', '🥓', '🍔', '🍟', '🍕', '🌭', '🌮', '🌯', '🥙', '🥚', '🍳', '🥘', '🍲', '🥗', '🍿', '🍱', '🍘', '🍙', '🍚', '🍛', '🍜', '🍝', '🍠', '🍢', '🍣', '🍤', '🍥', '🍡', '🍦', '🍧', '🍨', '🍩', '🍪', '🎂', '🍰', '🍫', '🍬', '🍭', '🍮', '🍯', '🍼', '🥛', '☕', '🍵', '🍶', '🍾', '🍷', '🍸', '🍹', '🍺', '🍻', '🥂', '🥃', '🍽', '🍴', '🥄', '🔪', '🏺', '🌍', '🌎', '🌏', '🌐', '🗺', '🗾', '🏔', '⛰', '🌋', '🗻', '🏕', '🏖', '🏜', '🏝', '🏞', '🏟', '🏛', '🏗', '🏘', '🏙', '🏚', '🏠', '🏡', '🏢', '🏣', '🏤', '🏥', '🏦', '🏨', '🏩', '🏪', '🏫', '🏬', '🏭', '🏯', '🏰', '💒', '🗼', '🗽', '⛪', '🕌', '🕍', '⛩', '🕋', '⛲', '⛺', '🌁', '🌃', '🌄', '🌅', '🌆', '🌇', '🌉', '♨', '🌌', '🎠', '🎡', '🎢', '💈', '🎪', '🎭', '🖼', '🎨', '🎰', '🚂', '🚃', '🚄', '🚅', '🚆', '🚇', '🚈', '🚉', '🚊', '🚝', '🚞', '🚋', '🚌', '🚍', '🚎', '🚐', '🚑', '🚒', '🚓', '🚔', '🚕', '🚖', '🚗', '🚘', '🚙', '🚚', '🚛', '🚜', '🚲', '🛴', '🛵', '🚏', '🛣', '🛤', '⛽', '🚨', '🚥', '🚦', '🚧', '🛑', '⚓', '⛵', '🛶', '🚤', '🛳', '⛴', '🛥', '🚢', '✈', '🛩', '🛫', '🛬', '💺', '🚁', '🚟', '🚠', '🚡', '🚀', '🛰', '🛎', '🚪', '🛌', '🛏', '🛋', '🚽', '🚿', '🛀', '🛀🏻', '🛀🏼', '🛀🏽', '🛀🏾', '🛀🏿', '🛁', '⌛', '⏳', '⌚', '⏰', '⏱', '⏲', '🕰', '🕛', '🕧', '🕐', '🕜', '🕑', '🕝', '🕒', '🕞', '🕓', '🕟', '🕔', '🕠', '🕕', '🕡', '🕖', '🕢', '🕗', '🕣', '🕘', '🕤', '🕙', '🕥', '🕚', '🕦', '🌑', '🌒', '🌓', '🌔', '🌕', '🌖', '🌗', '🌘', '🌙', '🌚', '🌛', '🌜', '🌡', '☀', '🌝', '🌞', '⭐', '🌟', '🌠', '☁', '⛅', '⛈', '🌤', '🌥', '🌦', '🌧', '🌨', '🌩', '🌪', '🌫', '🌬', '🌀', '🌈', '🌂', '☂', '☔', '⛱', '⚡', '❄', '☃', '⛄', '☄', '🔥', '💧', '🌊', '🎃', '🎄', '🎆', '🎇', '✨', '🎈', '🎉', '🎊', '🎋', '🎍', '🎎', '🎏', '🎐', '🎑', '🎀', '🎁', '🎗', '🎟', '🎫', '🎖', '🏆', '🏅', '🥇', '🥈', '🥉', '⚽', '⚾', '🏀', '🏐', '🏈', '🏉', '🎾', '🎱', '🎳', '🏏', '🏑', '🏒', '🏓', '🏸', '🥊', '🥋', '🥅', '🎯', '⛳', '⛸', '🎣', '🎽', '🎿', '🎮', '🕹', '🎲', '♠', '♥', '♦', '♣', '🃏', '🀄', '🎴', '🔇', '🔈', '🔉', '🔊', '📢', '📣', '📯', '🔔', '🔕', '🎼', '🎵', '🎶', '🎙', '🎚', '🎛', '🎤', '🎧', '📻', '🎷', '🎸', '🎹', '🎺', '🎻', '🥁', '📱', '📲', '☎', '📞', '📟', '📠', '🔋', '🔌', '💻', '🖥', '🖨', '⌨', '🖱', '🖲', '💽', '💾', '💿', '📀', '🎥', '🎞', '📽', '🎬', '📺', '📷', '📸', '📹', '📼', '🔍', '🔎', '🔬', '🔭', '📡', '🕯', '💡', '🔦', '🏮', '📔', '📕', '📖', '📗', '📘', '📙', '📚', '📓', '📒', '📃', '📜', '📄', '📰', '🗞', '📑', '🔖', '🏷', '💰', '💴', '💵', '💶', '💷', '💸', '💳', '💹', '💱', '💲', '✉', '📧', '📨', '📩', '📤', '📥', '📦', '📫', '📪', '📬', '📭', '📮', '🗳', '✏', '✒', '🖋', '🖊', '🖌', '🖍', '📝', '💼', '📁', '📂', '🗂', '📅', '📆', '🗒', '🗓', '📇', '📈', '📉', '📊', '📋', '📌', '📍', '📎', '🖇', '📏', '📐', '✂', '🗃', '🗄', '🗑', '🔒', '🔓', '🔏', '🔐', '🔑', '🗝', '🔨', '⛏', '⚒', '🛠', '🗡', '⚔', '🔫', '🏹', '🛡', '🔧', '🔩', '⚙', '🗜', '⚗', '⚖', '🔗', '⛓', '💉', '💊', '🚬', '⚰', '⚱', '🗿', '🛢', '🔮', '🛒', '🏧', '🚮', '🚰', '♿', '🚹', '🚺', '🚻', '🚼', '🚾', '🛂', '🛃', '🛄', '🛅', '⚠', '🚸', '⛔', '🚫', '🚳', '🚭', '🚯', '🚱', '🚷', '📵', '🔞', '☢', '☣', '⬆', '↗', '➡', '↘', '⬇', '↙', '⬅', '↖', '↕', '↔', '↩', '↪', '⤴', '⤵', '🔃', '🔄', '🔙', '🔚', '🔛', '🔜', '🔝', '🛐', '⚛', '🕉', '✡', '☸', '☯', '✝', '☦', '☪', '☮', '🕎', '🔯', '♈', '♉', '♊', '♋', '♌', '♍', '♎', '♏', '♐', '♑', '♒', '♓', '⛎', '🔀', '🔁', '🔂', '▶', '⏩', '⏭', '⏯', '◀', '⏪', '⏮', '🔼', '⏫', '🔽', '⏬', '⏸', '⏹', '⏺', '⏏', '🎦', '🔅', '🔆', '📶', '📳', '📴', '♻', '📛', '⚜', '🔰', '🔱', '⭕', '✅', '☑', '✔', '✖', '❌', '❎', '➕', '➖', '➗', '➰', '➿', '〽', '✳', '✴', '❇', '‼', '⁉', '❓', '❔', '❕', '❗', '〰', '©', '®', '™', '#️⃣', '*️⃣', '0️⃣', '1️⃣', '2️⃣', '3️⃣', '4️⃣', '5️⃣', '6️⃣', '7️⃣', '8️⃣', '9️⃣', '🔟', '💯', '🔠', '🔡', '🔢', '🔣', '🔤', '🅰', '🆎', '🅱', '🆑', '🆒', '🆓', 'ℹ', '🆔', 'Ⓜ', '🆕', '🆖', '🅾', '🆗', '🅿', '🆘', '🆙', '🆚', '🈁', '🈂', '🈷', '🈶', '🈯', '🉐', '🈹', '🈚', '🈲', '🉑', '🈸', '🈴', '🈳', '㊗', '㊙', '🈺', '🈵', '▪', '▫', '◻', '◼', '◽', '◾', '⬛', '⬜', '🔶', '🔷', '🔸', '🔹', '🔺', '🔻', '💠', '🔘', '🔲', '🔳', '⚪', '⚫', '🔴', '🔵', '🏁', '🚩', '🎌', '🏴', '🏳', '🇦🇨', '🇦🇩', '🇦🇪', '🇦🇫', '🇦🇬', '🇦🇮', '🇦🇱', '🇦🇲', '🇦🇴', '🇦🇶', '🇦🇷', '🇦🇸', '🇦🇹', '🇦🇺', '🇦🇼', '🇦🇽', '🇦🇿', '🇧🇦', '🇧🇧', '🇧🇩', '🇧🇪', '🇧🇫', '🇧🇬', '🇧🇭', '🇧🇮', '🇧🇯', '🇧🇱', '🇧🇲', '🇧🇳', '🇧🇴', '🇧🇶', '🇧🇷', '🇧🇸', '🇧🇹', '🇧🇻', '🇧🇼', '🇧🇾', '🇧🇿', '🇨🇦', '🇨🇨', '🇨🇩', '🇨🇫', '🇨🇬', '🇨🇭', '🇨🇮', '🇨🇰', '🇨🇱', '🇨🇲', '🇨🇳', '🇨🇴', '🇨🇵', '🇨🇷', '🇨🇺', '🇨🇻', '🇨🇼', '🇨🇽', '🇨🇾', '🇨🇿', '🇩🇪', '🇩🇬', '🇩🇯', '🇩🇰', '🇩🇲', '🇩🇴', '🇩🇿', '🇪🇦', '🇪🇨', '🇪🇪', '🇪🇬', '🇪🇭', '🇪🇷', '🇪🇸', '🇪🇹', '🇪🇺', '🇫🇮', '🇫🇯', '🇫🇰', '🇫🇲', '🇫🇴', '🇫🇷', '🇬🇦', '🇬🇧', '🇬🇩', '🇬🇪', '🇬🇫', '🇬🇬', '🇬🇭', '🇬🇮', '🇬🇱', '🇬🇲', '🇬🇳', '🇬🇵', '🇬🇶', '🇬🇷', '🇬🇸', '🇬🇹', '🇬🇺', '🇬🇼', '🇬🇾', '🇭🇰', '🇭🇲', '🇭🇳', '🇭🇷', '🇭🇹', '🇭🇺', '🇮🇨', '🇮🇩', '🇮🇪', '🇮🇱', '🇮🇲', '🇮🇳', '🇮🇴', '🇮🇶', '🇮🇷', '🇮🇸', '🇮🇹', '🇯🇪', '🇯🇲', '🇯🇴', '🇯🇵', '🇰🇪', '🇰🇬', '🇰🇭', '🇰🇮', '🇰🇲', '🇰🇳', '🇰🇵', '🇰🇷', '🇰🇼', '🇰🇾', '🇰🇿', '🇱🇦', '🇱🇧', '🇱🇨', '🇱🇮', '🇱🇰', '🇱🇷', '🇱🇸', '🇱🇹', '🇱🇺', '🇱🇻', '🇱🇾', '🇲🇦', '🇲🇨', '🇲🇩', '🇲🇪', '🇲🇫', '🇲🇬', '🇲🇭', '🇲🇰', '🇲🇱', '🇲🇲', '🇲🇳', '🇲🇴', '🇲🇵', '🇲🇶', '🇲🇷', '🇲🇸', '🇲🇹', '🇲🇺', '🇲🇻', '🇲🇼', '🇲🇽', '🇲🇾', '🇲🇿', '🇳🇦', '🇳🇨', '🇳🇪', '🇳🇫', '🇳🇬', '🇳🇮', '🇳🇱', '🇳🇴', '🇳🇵', '🇳🇷', '🇳🇺', '🇳🇿', '🇴🇲', '🇵🇦', '🇵🇪', '🇵🇫', '🇵🇬', '🇵🇭', '🇵🇰', '🇵🇱', '🇵🇲', '🇵🇳', '🇵🇷', '🇵🇸', '🇵🇹', '🇵🇼', '🇵🇾', '🇶🇦', '🇷🇪', '🇷🇴', '🇷🇸', '🇷🇺', '🇷🇼', '🇸🇦', '🇸🇧', '🇸🇨', '🇸🇩', '🇸🇪', '🇸🇬', '🇸🇭', '🇸🇮', '🇸🇯', '🇸🇰', '🇸🇱', '🇸🇲', '🇸🇳', '🇸🇴', '🇸🇷', '🇸🇸', '🇸🇹', '🇸🇻', '🇸🇽', '🇸🇾', '🇸🇿', '🇹🇦', '🇹🇨', '🇹🇩', '🇹🇫', '🇹🇬', '🇹🇭', '🇹🇯', '🇹🇰', '🇹🇱', '🇹🇲', '🇹🇳', '🇹🇴', '🇹🇷', '🇹🇹', '🇹🇻', '🇹🇼', '🇹🇿', '🇺🇦', '🇺🇬', '🇺🇲', '🇺🇸', '🇺🇾', '🇺🇿', '🇻🇦', '🇻🇨', '🇻🇪', '🇻🇬', '🇻🇮', '🇻🇳', '🇻🇺', '🇼🇫', '🇼🇸', '🇽🇰', '🇾🇪', '🇾🇹', '🇿🇦', '🇿🇲', '🇿🇼'];
            const EMOJI_DELAY = 3000;

            const input = dom.chat__input;
            const fileinput = dom.chat__file;
            let active = 'message';

            function getActive () { return active; }

            function changePreview (target = 'message') {
                dom.chat__messagepreview.classList.toggle('nondisplay', (target === 'message') ? false : true);
                dom.chat__filepreview.classList.toggle('nondisplay', (target === 'file') ? false : true);
                dom.chat__pollpreview.classList.toggle('nondisplay', (target === 'poll') ? false : true);
                active = target;
            }

            function submit () {
                dom.emojipicker.checked = false; // TBD: Maybe create a structure for this?
                switch (active) {
                    case 'message':
                        chat.send('message', input.value.trim());
                        input.value = '';
                        input.style.height = 'auto';
                        input.style.height = (input.scrollHeight) + 'px';
                        input.focus();
                        break;
                    case 'file':
                        chat.send('file', files.add(fileinput.files[0]));
                        fileinput.value = '';
                        changePreview();
                        break;
                    case 'poll':
                        const data = chat.poll.generate();
                        if (data) {
                            chat.send('poll', data);
                            chat.poll.cleanse();
                            changePreview();
                        }
                        break;
                }
            }

            dom.chat__form.addEventListener('submit', submit);

            input.addEventListener('focus', function (e) {
                if (MOBILE_AGENT) dom.sidebar.classList.toggle('sidebar--big', true);
            });

            input.addEventListener('blur', function (e) {
                if (MOBILE_AGENT) dom.sidebar.classList.toggle('sidebar--big', false);
            });

            input.addEventListener('keydown', function (e) {
                if (e.keyCode === 13 && !e.shiftKey) {
                    dom.chat__sendbutton.click();
                    e.preventDefault();
                }
            });

            input.addEventListener('keyup', function (e) {
                input.style.height = 'auto';
                input.style.height = input.scrollHeight + 'px';
            });

            // File Preview
            dom.chat__file.addEventListener('change', function (e) {
                if (dom.chat__file.files.length === 1) {
                    dom.emojipicker.checked = false;
                    dom.filepreview__icon.innerHTML = files.getFileIcon(fileinput.files[0].type);
                    dom.filepreview__name.textContent = fileinput.files[0].name;
                    dom.filepreview__size.textContent = files.convertToFileSize(fileinput.files[0].size);
                    changePreview('file');
                }
            });

            dom.filepreview__close.addEventListener('click', function (e) {
                fileinput.value = '';
                changePreview();
            });

            // Poll Preview
            dom.polltoggle.addEventListener('change', function (e) {
                changePreview((active !== 'poll') ? 'poll' : 'message' );
                dom.sidebar.classList.toggle('sidebar--big', (active === 'poll'));
            });

            dom.pollpreview__close.addEventListener('click', function (e) {
                changePreview();
                dom.sidebar.classList.toggle('sidebar--big', false);
            });

            // Emoji-related stuff.
            function selectEmoji (e) {
                if (e.target.id !== 'emoji__list') {
                    if (input.focus) {
                        const start = input.selectionStart;
                        const end = input.selectionEnd;
                        const text = input.value;
                        const before = text.substring(0, start);
                        const after = text.substring(end, text.length);
                        input.value = (before + e.target.textContent + after);
                        input.selectionStart = input.selectionEnd = start + e.target.textContent.length;
                        input.focus();
                    } else {
                        input.value += e.target.textContent;
                    }
                }
            }

            // Defer generating emoji.
            setTimeout(() => {
                const emojiFragment = document.createDocumentFragment();
                for (let i = 0, len = EMOJI.length; i < len; i++) {
                    const emoji = createEle('div');
                    emoji.textContent = EMOJI[i];
                    emojiFragment.appendChild(emoji);
                }
                dom.emoji__list.appendChild(emojiFragment);
                dom.emoji__list.addEventListener('click', selectEmoji);
            }, EMOJI_DELAY);

            return {
                submit: submit,
                active: getActive
            };

        })();

        // Chat: Poll Functionality
        chat.poll = (function () {

            const MAX_OPTIONS = 10;
            let options = [];
            let polls = {};

            function PollOption () {
                this.dom = {};

                this.dom.wrapper = createEle('div');
                this.dom.wrapper.className = 'pollpreview__option';

                this.dom.selector = createEle('input');
                this.dom.selector.type = (dom.pollpreview__multi.checked) ? 'checkbox' : 'radio';
                this.dom.selector.className = 'pollpreview__selector';
                this.dom.selector.disabled = true;
                
                this.dom.input = createEle('input');
                this.dom.input.type = 'text';
                this.dom.input.placeholder = 'Enter Poll Option';
                this.dom.input.className = 'pollpreview__input';

                this.dom.action = createEle('button');
                this.dom.action.type = 'button';
                this.dom.action.className = 'pollpreview__action';
                this.dom.action.innerHTML = assets.icons.close;
                this.dom.action.tabIndex = -1;
                this.dom.action.addEventListener('click', this.remove.bind(this));

                this.dom.wrapper.appendChild(this.dom.selector);
                this.dom.wrapper.appendChild(this.dom.input);
                this.dom.wrapper.appendChild(this.dom.action);
            }

            PollOption.prototype.getElement = function () {
                return this.dom.wrapper;
            };

            PollOption.prototype.setValue = function (content) {
                this.dom.input.value = content;
            };

            PollOption.prototype.getValue = function () {
                return this.dom.input.value;
            };

            PollOption.prototype.remove = function () {
                // Remove event listeners.
                chat.poll.remove(this);
            };
            
            PollOption.prototype.removable = function (state) {
                this.dom.action.disabled = state;
            };

            PollOption.prototype.changeSelector = function (type) {
                this.dom.selector.type = type;
            };

            function cleanse () {
                if (options.length > 2) {
                    for (let i = 2, len = options.length; i < len; i++) {
                        options[i].dom.wrapper.remove();
                    }
                    options.splice(2);
                }
                for (let i = 0, len = options.length; i < len; i++) {
                    options[i].setValue('');
                }
                updateRemoveable();
            }

            function updateRemoveable () {
                const state = (options.length === 2);
                for (let i = 0, len = options.length; i < len; i++) {
                    options[i].removable(state);
                }
            }

            function togglePollType () {
                const type = (dom.pollpreview__multi.checked) ? 'checkbox' : 'radio';
                for (let i = 0, len = options.length; i < len; i++) {
                    options[i].changeSelector(type);
                }
            }

            function add () {
                if (options.length < MAX_OPTIONS) {
                    const entry = new PollOption();
                    options.push(entry);
                    dom.pollpreview__list.appendChild(entry.getElement());
                    entry.dom.input.focus();
                    updateRemoveable();
                    if (options.length === MAX_OPTIONS) 
                        dom.pollpreview__add.disabled = true;
                }
            }

            function remove (entry) {
                entry.dom.wrapper.remove();
                options.splice(options.indexOf(entry), 1);
                updateRemoveable();
                if (options.length < MAX_OPTIONS)
                    dom.pollpreview__add.disabled = false;
            }

            function generate () {
                let data = [];
                for (let i = 0, len = options.length; i < len; i++) {
                    const val = options[i].getValue().trim();
                    if (val.length > 0 && !data.includes[val])
                        data.push(val);
                }
                if (data.length > 1) {
                    const hash = (user.pid + Date.now()).hashCode();
                    polls[hash] = {
                        hash: hash,
                        options: data,
                        multi: dom.pollpreview__multi.checked
                    };
                    return polls[hash];
                } else {
                    return false;
                }
            }

            function handleVote (hash, pid, votes) {
                polls[hash].voters = polls[hash].voters || {};
                polls[hash].voters[pid] = votes;
            }

            function getVotingData (hash) {
                const voters = getVoters(hash);
                let total = {}, votes = null;
                for (let i = 0, len = voters.length; i < len; i++) {
                    votes = polls[hash].voters[voters[i]];
                    for (let j = 0, lenj = votes.length; j < lenj; j++) {
                        total[votes[j]] = (total[votes[j]] || 0) + 1;
                    }
                }
                return {
                    voters: voters,
                    votes: total
                };
            }

            function getVoters (hash) {
                return (polls.hasOwnProperty(hash) && 
                    polls[hash].hasOwnProperty('voters')) ? 
                        Object.keys(polls[hash].voters) : [];
            }

            dom.pollpreview__multi.addEventListener('change', togglePollType);
            dom.pollpreview__add.addEventListener('click', add);

            // Add two options by default.
            add(); add();

            return {
                toggleType: togglePollType,
                add: add,
                remove: remove,
                cleanse: cleanse,
                generate: generate,
                vote: handleVote,
                data: getVotingData
            };

        })();

        files.list = {};

        // Files: returns icon representing file type
        files.getFileIcon = function (type) {
            switch (type) {
                case 'image':
                    return assets.icons.image;
                default:
                    return assets.icons.file;
            }
        };

        // Files: generates formatted file size string from raw size
        files.convertToFileSize = function (size) {
            const power = 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024));
            return (size / Math.pow(1024, power)).toFixed(2) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][power];
        };

        // Files: downloads blob as file
        files.downloadBlob = function (blob, fileName = 'Unknown File') {
            const downloadAnchor = createEle('a');
            // Cleanse
            downloadAnchor.textContent = '';
            downloadAnchor.removeAttribute('download');
            if (downloadAnchor.href) {
                URL.revokeObjectURL(downloadAnchor.href);
                downloadAnchor.removeAttribute('href');
            }
            // Download
            downloadAnchor.href = window.URL.createObjectURL(blob);
            downloadAnchor.download = fileName;
            downloadAnchor.click();
        };

        files.send = function (func, hash, pid) {

            if (!files.list.hasOwnProperty(hash))
                return;

            const file = files.list[hash];

            // If peer exists and file not currently downloading.
            if (pid in peers && !peers[pid].fileChannels[hash]) {
                
                peers[pid].fileChannels[hash] = 
                    peers[pid].pc.createDataChannel(func + ':'  + file.name + ':' + hash);
                peers[pid].fileChannels[hash].binaryType = 'arraybuffer';

                // TBD Possible memory leak due to in-line event listeners
                peers[pid].fileChannels[hash].addEventListener('open', function () {
                    let fileReader = new FileReader();
                    let offset = 0;
                    const readSlice = (o) => {
                        const slice = file.slice(offset, o + MAX_MESS_SIZE);
                        fileReader.readAsArrayBuffer(slice);
                    };
                    fileReader.addEventListener('load', (e) => {
                        peers[pid].fileChannels[hash].send(e.target.result);
                        offset += e.target.result.byteLength;
                        if (offset < file.size) {
                            readSlice(offset);
                        } else {
                            peers[pid].fileChannels[hash].send('EOF');
                        }
                    });
                    readSlice(0);             
                });

                peers[pid].fileChannels[hash].addEventListener('close', function () {
                    // Transfer completed or halted
                    delete peers[pid].fileChannels[hash];
                });

            }

        };

        files.download = function (hash) {
            if (files.list.hasOwnProperty(hash))
                files.downloadBlob(files.list[hash], files.list[hash].name);
        };

        files.add = (function (file) {

            let count = 0;

            function add (file) {
                const hash = (user.pid + file.name + file.size + file.type + count).hashCode();
                files.list[hash] = file;
                const data = {
                    name: file.name,
                    size: file.size,
                    type: file.type,
                    id: count,
                    hash: hash
                };
                count++;
                return data;
            }

            return add;

        })();

        files.remove = function (hash) {
            if (files.list.hasOwnProperty(hash))
                delete files.list[hash];
        };

        // Socket
        socket = (function () {

            let socket = null;
            let handles = {};

            function emit (label, data) {
                socket.emit(label, data);
            }

            function join () {

                user.pid = socket.id;
                user.blocked = false;

                // Add self to userlist.
                ui.userlist.add(user.pid);

                // Hide fullscreen prompt.
                ui.fullscreenPrompt.hide();

                socket.emit('join', {
                    channel: room.channel,
                    room: room.name,
                    id: room.id,
                    key: (user.key.length) ? encodeURIComponent(user.key.join('')) : ''
                });

                events.emit('join', user);

            }

            function quit () {
                socket.emit('part', room.channel);
            }

            function disconnect () {
                peerUtils.close();
                peers = {};
            }

            function log (note = undefined) {
                socket.emit('log', {
                    note: (note) ? note : ''
                });
            }

            function admin (cmd = 'status', extension = undefined) {
                let data =  {
                    cmd: cmd,
                    channel: room.channel,
                    room: room.name,
                    id: room.id,
                    key: (user.key.length) ? encodeURIComponent(user.key.join('')) : ''
                };
                if (extension) Object.assign(data, extension);
                socket.emit('admin', data);
            }

            function lock () { admin('lock'); }
            function unlock () { admin('unlock'); }
            function kick (pid) { admin('kick', { peer_id: pid }); }

            function handleBlocked (config) {
                user.blocked = true;
                switch (config.status) {
                    case 'hosted':
                        ui.fullscreenPrompt.prompt('This room\'s host hasn\'t arrived yet.');
                        dom.information__shareroom.classList.toggle('nondisplay', true);
                        break;
                    case 'badCode':
                        break;
                    case 'locked':
                        ui.controls.lockRoom.set(true);
                        ui.fullscreenPrompt.prompt('This room is currently locked. Only hosts can currently enter.');
                        dom.information__shareroom.classList.toggle('nondisplay', true);
                        break;
                }
                events.emit('blocked', config.status);
            }

            function handleAdmin (config) {
                switch (config.cmd) {
                    case 'lock':
                        chat.add('notification', {}, 'locked the room.');
                        ui.controls.lockRoom.set(true);
                        broadcast('lock', true);
                        break;
                    case 'unlock':
                        chat.add('notification', {}, 'unlocked the room.');
                        ui.controls.lockRoom.set(false);
                        broadcast('lock', false);
                        break;
                    case 'status':
                        if (config.lock === 0) ui.controls.lockRoom.set(false);
                        if (config.lock === 1) ui.controls.lockRoom.set(true);
                        break;
                }
                events.emit('admin', config.cmd);
            }

            function handleAdd (config) {
                peerUtils.add(config);
            }

            function handleRemove (config) {
                const pid = config.peer_id;
                if (pid === user.pid) user.quit(true); // User kicked
                else peerUtils.remove(pid, config.type); // Peer removed
            }

            function handleIceCandidate (config) {
                peerUtils.iceCandidate(config.peer_id, config.ice_candidate);
            }

            function handleSessionDescription (config) {
                peerUtils.sessionDescription(config.peer_id, config.session_description);
            }

            function register (name, callback) {
                handles[name] = callback;
                if (socket)
                    socket.on(name, callback);
            }

            function init () {

                socket = io(SIG_SERVER);

                // Any handlers prior to initialization.
                const keys = Object.keys(handles);
                for (let i = 0, len = keys.length; i < len; i++) {
                    socket.on(keys[i], handles[keys[i]]);
                }

                // Default handlers.
                register('connect', join);
                register('rejoin', join);
                register('disconnect', disconnect);
                register('blocked', handleBlocked);
                register('admin', handleAdmin);
                register('addPeer', handleAdd);
                register('removePeer', handleRemove);
                register('iceCandidate', handleIceCandidate);
                register('sessionDescription', handleSessionDescription);

            }

            return {
                emit: emit,
                join: join,
                quit: quit,
                log: log,
                admin: admin,
                status: admin,
                lock: lock,
                unlock: unlock,
                kick: kick,
                init: init,
                register: register
            };

        })();

        // Initialization
        (function () {

            ui.fullscreenPrompt.error('Attempting to connect to the key server...');
            window.fetch(room.keyURL).then((res) => {
                ui.fullscreenPrompt.hide();
                return res.text();
            }).then((text) => {

                const obj = JSON.parse(text);

                if (obj.status === 200) {

                    room.id = obj.id;

                    // Adjust URL prior to replacing internal name with hashed name.
                    window.history.replaceState(null, null, ('/' + room.name + '/' + room.id));

                    room.name = obj.room;
                    room.channel = obj.channel;

                    // Add URL to shareable link
                    dom.shareform__link.value = window.location.href;

                    // Set host key if available.
                    if (obj.hasOwnProperty('key')) {
                        user.key = obj.key.split('');
                        ui.enableHost();
                    }

                    // Change share text if room is hosted
                    dom.share__text.textContent = 'Share This ' + 
                        ((obj.hasOwnProperty('hosted') && obj.hosted === 1) ? 'Hosted ' : '') +
                        ((obj.hasOwnProperty('starttime')) ? 'Scheduled ' : '') +
                        'Room';

                    // Connect to the signaling server.
                    socket.init();

                } else {

                    dom.information__shareroom.classList.toggle('nondisplay', true);

                    events.emit('keyerror', obj.error);

                    switch (obj.error) {
                        case 'hash':
                            ui.fullscreenPrompt.prompt('We\'ve encountered an internal room configuration error.<br>Please check your browser settings and reload the page.');
                            break;
                        case 'csum':
                            ui.fullscreenPrompt.prompt('We could not find your specific room.<br>Please check your URL and reload the page.');
                            break;
                        case 'early':
                            const scheduledDate = (obj.starttime) ? new Date(obj.starttime * 1000) : false;
                            const currentDate = (obj.curtime) ? new Date(obj.curtime * 1000) : new Date();
                            const delay = scheduledDate.getTime() - currentDate.getTime();
                            if (scheduledDate && delay > 0) { 
                                ui.fullscreenPrompt.prompt('This room is scheduled to open on ' + 
                                    scheduledDate.toLocaleString(undefined, { hour12: true, weekday: 'long', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', timeZoneName: 'short' }) + 
                                    '.');
                                dom.shareform__link.value = window.location.href;
                                dom.information__shareroom.classList.toggle('nondisplay', false);
                                if (delay < 2147483640) setTimeout(window.location.reload.bind(window.location), delay);
                            } else {
                                ui.fullscreenPrompt.prompt('There was a room scheduling error.<br>Please reload the page.');
                            }
                            break;
                        case 'time bad':
                            ui.fullscreenPrompt.prompt('This room has an invalid scheduling date.<br>Please check your URL and reload the page.');
                            break;
                        case 'time old':
                            ui.fullscreenPrompt.prompt('This room has an invalid scheduling date.<br>Please check your URL and reload the page.');
                            break;
                        default:
                            ui.fullscreenPrompt.prompt('There was an unknown error.<br>Please check your URL and reload the page.');
                            break;
                    }
                    
                }
            }).catch((error) => {
                // Key Server Failure
                ui.fullscreenPrompt.prompt('Connecting to the key server failed!<br>Please check your connection and reload the page.');
                dom.information__shareroom.classList.toggle('nondisplay', true);
            });

        })();

        // Expose for public access:
        return {
            assets: assets,
            user: user,
            peers: peers,
            room: room,
            chat: chat,
            broadcast: broadcast,
            receive: Peer.prototype.registerMessageHandler,
            on: events.on,
            off: events.off
        };

    })();

});
